<template>

<div class="wrapper wrapper-content bet-page-shell">
  <div class="container-fluid bet-page-container">
 


<div class="bet-page-header-wrap">
  <div class="col-xs-12">
    <div class="ibox m-b-md bet-hero-card">
<div class="ibox-title bet-hero-card__title">
  <div class="bet-hero-card__heading">
    <div class="bet-hero-card__crumb">
      <router-link :to="{name: 'lottery'}" class="bet-hero-card__crumb-link">แทงหวย</router-link>
      <span class="bet-hero-card__crumb-sep">/</span>
      <span>{{ gove_round_data.description }}</span>
    </div>
    <h3 class="bet-hero-card__name">{{ gove_round_data.description }}</h3>
  </div>
        <div class="clearfix"></div>
      </div> 
      <div class="ibox-content no-padding bet-hero-card__content">
        <nav class="navbar navbar-default nav-slug bet-slug-nav">
          <div class="collapse navbar-collapse in no-borders">
            <ul class="nav navbar-nav bet-slug-nav__list">
              <li class="text-center mobile-full-width" ref="rulebox" v-bind:class="{ 'active': !ruleIsHidden }" v-on:click="hiddenMethod('rule', $event)" >
                <a href="#boxrule" class="btn-bet-info animated">กติกาหวยรัฐบาล</a>
                </li> 
              <li class="text-center" ref="upbox" v-bind:class="{ 'active': !upIsHidden }" v-on:click="hiddenMethod('threetop', $event)">
                <a href="#" class="btn-bet-info animated">สามตัว</a>
              </li> 
              <li class="text-center has-mobile-border" ref="downbox" v-bind:class="{ 'active': !downIsHidden }" v-on:click="hiddenMethod('twodown', $event)">
                        <a href="#" class="btn-bet-info animated">สองตัว</a>
              </li> 
              <li class="text-center" ref="runningbox" v-bind:class="{ 'active': !runningIsHidden }" v-on:click="hiddenMethod('running', $event)">
                <a href="#" class="btn-bet-info animated">เลขวิ่ง</a>
              </li>
              <li class="text-center border-left">
                <a href="/govhome#number-sets-modal" data-toggle="modal" class="btn-bet-info animated" @click="loadUserNumber">เลขชุด / ดึงโพย</a>
              </li>

            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>







<div class="ibox bet-main-shell">
<div class="col-md-9 bet-main-column">

<div id="boxrule" ref="boxrule" class="ibox bet-section-card" style="position: relative;" v-show="!ruleIsHidden">
  <div>
    <div class="ibox">
      <div class="ibox-content">
        <h4>
          <span style="font-size: 12pt;"><span style="font-weight: bold;">หวยรัฐบาล</span>&nbsp;</span>
        </h4>
        <ol>
          <li><span style="font-weight: bold; line-height: 18.5714px;">ระบบ เปิดรับแทงทุกวัน ออนไลน์ 24 ชม. ท่านสามารถเดิมพันล่วงหน้าได้เลยค่ะ</span></li> <li><span style="font-weight: bold; line-height: 1.42857;">ระบบ ปิดรับแทงเวลา 15:20 น. หากมีการเปลี่ยนแปลงทางบริษัทฯจะแจ้งให้ทราบล่วงหน้า 1 วันค่ะ</span></li>
        </ol> 
        <p><span style="font-size: 10pt; color: rgb(255, 0, 0);"><span style="line-height: 15.7143px;"><strong>เลขอั้น และ เลขเต็ม</strong></span></span></p> <p><span style="font-size: 12pt;"><strong>เลขอั้น คือเลขที่เจ้ามือปิดรับแทงหรือจ่ายครึ่งราคาก่อนวันหวยออก 1 วัน</strong></span></p> <p><span style="font-size: 12pt;"><strong>เลขเต็ม คือเลขที่มีการสั่งซื้อเข้ามาเป็นจำนวนมาก ทำให้เจ้ามือปิดรับเลขตัวนั้นๆ</strong></span></p>  <p><span style="font-size: 12pt;"><strong>(เลขเต็มอาจะมีในช่วงเวลา 12:00น.ถึงเวลา15:30 หรืออาจะไม่มี)</strong></span></p> <p><span style="font-size: 12pt;"><strong>ส่วนท่านที่แทงเลขอั้นหวยรัฐบาลเข้ามาก่อนวันที่ 15 หรือก่อนประกาศเลขอั้น ทางทีมงานอาจะมีการยกเลิกในบางกรณี(ย้ำนะครับบางกรณีเท่านั้น เช่น เลขดังจริงๆ เลขที่เจ้ามือปิดรับทุกเจ้าไม่มีเจ้ามือไหนรับ) ขอให้ท่านเข้าไปเช็คโพยที่ท่านแทงเลขอั้นเข้ามา หากมีการโดนยกเลิกสถานะจะแจ้งเตือน และเอเย่นต์จะทำการติดต่อท่านเพื่อแจ้งให้ทราบครับ แต่หากโพยยังอยู่แสดงว่าสถานะ รับแทง ปกติครับ</strong></span></p> <p>&nbsp;</p> <p><span style="font-size: 10pt;"><strong><span style="line-height: 1.42857;">ตาราง ราคาการจ่ายปกติ และ ราคาจ่ายแบบผันราคา</span></strong></span></p>

        <div class="responsive-table">
          <div style="overflow-x:auto;">
            <table width="782" style="height: 251px;">
              <tbody>
                <tr>
                  <td style="text-align: left;"><strong>&nbsp;ประเภทหวย/ราคาจ่าย</strong></td>
                  <td style="text-align: left;"><strong>&nbsp;ราคาปกติ</strong></td>
                </tr>
                <tr>
                  <td>&nbsp;3 ตัวบนตรง</td> 
                  <td>&nbsp;{{ bettypeRateMapping.threetop }}</td>
                </tr> 
                <tr>
                  <td>&nbsp;3 ตัวโต๊ด</td> 
                  <td>&nbsp;{{ bettypeRateMapping.threemix }}</td>
                </tr> 
                <tr>
                  <td>&nbsp;2 ตัวบน - ล่าง</td> 
                  <td>&nbsp;{{ bettypeRateMapping.twotop }}</td> 
                </tr> 
                <tr>
                  <td>&nbsp;เลขวิ่ง 3 ตัวบน</td> 
                  <td>&nbsp;{{ bettypeRateMapping.runtop }}</td>
                </tr> 
                <tr>
                  <td>&nbsp;เลขวิ่ง 2 ตัวล่าง</td> 
                  <td>&nbsp;{{ bettypeRateMapping.rundown }}</td>
                </tr>
              </tbody>
            </table> 
          </div>
        </div>

        <p><small style="color: rgb(204, 0, 0);">** ตารางสามารถเลื่อนขวาได้ในกรณีใช้มือถือ</small></p> 
        <p>&nbsp;** หากราคามีการเปลี่ยนแปลง ทางบริษัทฯจะแจ้งให้ทราบล่วงหน้าก่อนมีการเปลี่ยนแปลง 7 วันค่ะ **</p> 
        <p style="padding-left: 30px;">&nbsp;</p> 
        <p>&nbsp;</p>
      </div>
    </div>
  </div>
</div>


  <div id="box-numbers" ref="boxnumbers" class="ibox bet-section-card" style="position: relative;" v-show="!numberIsHidden">
    <div class="ibox-title">
      <h5>ปิดรับ  {{ formatDate(gove_round_data.expiration_date) }}</h5>
      <div class="clearfix"></div>
      <form class="navbar-form navbar-right nav-search-permutation">
        <!-- <div class="form-group">
          <div class="input-group">
            <span id="basic-addon1" class="input-group-addon"><i class="fa fa-search"></i></span> 
            <input ref="searchnum" number="" type="number" placeholder="ค้นหาตัวเลข" class="form-control" @input="searchNumber" @change="searchNumber">
          </div>
        </div>  -->
        <button type="button" class="btn  btn-default"  @click="setPermutFlag" ><i class="fa fa-fw fa-random"></i>กลับเลข</button>
      </form>
    </div>

    <div id="betselected" class="ibox-title bet-price-toolbar">
      <h5>เลือกราคาแทงขั้นต่ำ</h5>
      <div class="clearfix"></div>

      <div class="money-input bet-money-input">
        <div class="row">

          <label for="inlineFold" class="col-xs-6 col-md-9 line-55">
          </label> 

          <div class="col-xs-6 col-md-3">
            <!-- <span class="input-group">
              <input type="text" placeholder="" maxlength="5" class="form-control money" :value="formatMoney(customBetValue)" @change="setCustomBetValue" @keypress="onlyNumber" >
            </span> 
            <button class="visible-xs pull-right btn btn-secondary" @click="clearBetValue">เคลียร์</button> -->

            <div class="input-group">
              <input type="text" placeholder="" maxlength="5" class="form-control money" :value="formatMoney(customBetValue)" @change="setCustomBetValue" @keypress="onlyNumber" >
              <span class="input-group-btn">
                <button class="pull-right btn btn-secondary" @click="clearBetValue">เคลียร์</button>
              </span>
            </div>

          </div> 

          <div class="col-xs-12 col-md-9 money-chips bet-money-chips">
            <button ref="bet1" class="coin-chip coin-chip--1" @click="setBetValue(1, $event)">1</button>
            <button ref="bet5" class="coin-chip coin-chip--5" @click="setBetValue(5, $event)">5</button>
            <button ref="bet10" class="coin-chip coin-chip--10" @click="setBetValue(10, $event)">10</button>
            <button ref="bet50" class="coin-chip coin-chip--50" @click="setBetValue(50, $event)">50</button>
            <button ref="bet100" class="coin-chip coin-chip--100" @click="setBetValue(100, $event)">100</button>
            <button ref="bet500" class="coin-chip coin-chip--500" @click="setBetValue(500, $event)">500</button>
          </div>

          <!-- <div class="hidden-xs col-md-3">
            <button class="btn btn btn-secondary" @click="clearBetValue">เคลียร์</button>
          </div> -->

        </div>
      </div>

    </div>

    <div class="ibox-content">
      <div class="subtype-group bet-subtype-group">

        <div class="row" v-if="!upIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm no-margins " v-on:click="numClickMethod('threetop', $event)" v-bind:class="{ 'btn-primary': buttthreetopIsActive, 'btn-default': !buttthreetopIsActive }">
                    {{ bettypeTextMapping.threetop }}
                    ({{ bettypeRateMapping.threetop }})
                  </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm no-margins" v-on:click="numClickMethod('threemix', $event)" v-bind:class="{ 'btn-primary': buttthreemixIsActive, 'btn-default': !buttthreemixIsActive }">
                    {{ bettypeTextMapping.threemix }}
                    ({{ bettypeRateMapping.threemix }})
            </button>
          </div>
        </div> 
        
        <div class="row" v-if="!frontIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('threefront', $event)" v-bind:class="{ 'btn-primary': buttthreefrontIsActive, 'btn-default': !buttthreefrontIsActive }">
                    {{ bettypeTextMapping.threefront }}
                    ({{ bettypeRateMapping.threefront }})
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('threedown', $event)" v-bind:class="{ 'btn-primary': buttthreedownIsActive, 'btn-default': !buttthreedownIsActive }">
                    {{ bettypeTextMapping.threedown }}
                    ({{ bettypeRateMapping.threedown }})
            </button>
          </div>
        </div> 

        <div class="row" v-if="!downIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('twotop', $event)" v-bind:class="{ 'btn-primary': butttwotopIsActive, 'btn-default': !butttwotopIsActive }">
                    {{ bettypeTextMapping.twotop }}
                    ({{ bettypeRateMapping.twotop }})
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('twodown', $event)" v-bind:class="{ 'btn-primary': butttwodownIsActive, 'btn-default': !butttwodownIsActive }">
                    {{ bettypeTextMapping.twodown }}
                    ({{ bettypeRateMapping.twodown }})
            </button>
          </div>
        </div>

        <div class="row" v-if="!runningIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('runtop', $event)" v-bind:class="{ 'btn-primary': buttruntopIsActive, 'btn-default': !buttruntopIsActive }">
                    {{ bettypeTextMapping.runtop }}
                    ({{ bettypeRateMapping.runtop }})
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('rundown', $event)" v-bind:class="{ 'btn-primary': buttrundownIsActive, 'btn-default': !buttrundownIsActive }">
                    {{ bettypeTextMapping.rundown }}
                    ({{ bettypeRateMapping.rundown }})
            </button>
          </div>
        </div>

        <div class="row" v-if="!hilowIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('hibet', $event)" v-bind:class="{ 'btn-primary': butthibetIsActive, 'btn-default': !butthibetIsActive }">
              สูง
              (50)
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('lowbet', $event)" v-bind:class="{ 'btn-primary': buttlowbetIsActive, 'btn-default': !buttlowbetIsActive }">
              ต่ำ
              (50)
            </button>
          </div>
        </div>

        <div class="row" v-if="!evenoddIsHidden">
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('evenbet', $event)" v-bind:class="{ 'btn-primary': buttevenbetIsActive, 'btn-default': !buttevenbetIsActive }">
              คู่
              (50)
            </button>
          </div> 
          <div class="col-xs-6">
            <button type="button" class="btn btn-block p-sm " v-on:click="numClickMethod('oddbet', $event)" v-bind:class="{ 'btn-primary': buttoddbetIsActive, 'btn-default': !buttoddbetIsActive }">
              คี่
              (50)
            </button>
          </div>
        </div>

      </div> 

  <div class="row m-t-md" id="boxup" ref="boxup" v-show="!upIsHidden">
    <div class="col-xs-12">
      <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div> 
      <div ref="numbertab" class="tabbable">
        <ul class="nav nav-tabs nav-justified">
          <li class="active"><a href="/govhome#uptab1" data-toggle="tab">000</a></li> 
          <li><a href="/govhome#uptab2" data-toggle="tab">100</a></li> 
          <li><a href="/govhome#uptab3" data-toggle="tab">200</a></li> 
          <li><a href="/govhome#uptab4" data-toggle="tab">300</a></li> 
          <li><a href="/govhome#uptab5" data-toggle="tab">400</a></li> 
          <li><a href="/govhome#uptab6" data-toggle="tab">500</a></li> 
          <li><a href="/govhome#uptab7" data-toggle="tab">600</a></li> 
          <li><a href="/govhome#uptab8" data-toggle="tab">700</a></li> 
          <li><a href="/govhome#uptab9" data-toggle="tab">800</a></li> 
          <li><a href="/govhome#uptab10" data-toggle="tab">900</a></li>
        </ul> 
        <div class="tab-content m-t-md">
          <div id="uptab1" class="tab-pane animated fadeIn active in">
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(0, 99, 3)" :key="'up000-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color0" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab2" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(100, 199, 3)" :key="'up100-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color1" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab3" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(200, 299, 3)" :key="'up200-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color2" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab4" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(300, 399, 3)" :key="'up300-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color3" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab5" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(400, 499, 3)" :key="'up400-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color4" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab6" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(500, 599, 3)" :key="'up500-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color5" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab7" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(600, 699, 3)" :key="'up600-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color6" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab8" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(700, 799, 3)" :key="'up700-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color7" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab9" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(800, 899, 3)" :key="'up800-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color8" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="uptab10" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(900, 999, 3)" :key="'up900-' + index">
                <button type="button" :ref="'up_' + num" class="btn btn-block btn-default bet-number-tile color9" @click="addCart( num, 'up', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div> 

  <div class="row m-t-md" id="boxfront" ref="boxfront" v-show="!frontIsHidden">
    <div class="col-xs-12">
      <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div> 
      <div ref="numbertab" class="tabbable">
        <ul class="nav nav-tabs nav-justified">
          <li class="active"><a href="/govhome#fronttab1" data-toggle="tab">000</a></li> 
          <li><a href="/govhome#fronttab2" data-toggle="tab">100</a></li> 
          <li><a href="/govhome#fronttab3" data-toggle="tab">200</a></li> 
          <li><a href="/govhome#fronttab4" data-toggle="tab">300</a></li> 
          <li><a href="/govhome#fronttab5" data-toggle="tab">400</a></li> 
          <li><a href="/govhome#fronttab6" data-toggle="tab">500</a></li> 
          <li><a href="/govhome#fronttab7" data-toggle="tab">600</a></li> 
          <li><a href="/govhome#fronttab8" data-toggle="tab">700</a></li> 
          <li><a href="/govhome#fronttab9" data-toggle="tab">800</a></li> 
          <li><a href="/govhome#fronttab10" data-toggle="tab">900</a></li>
        </ul> 
        <div class="tab-content m-t-md">
          <div id="fronttab1" class="tab-pane animated fadeIn active in">
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(0, 99, 3)" :key="'front000-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color0" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab2" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(100, 199, 3)" :key="'front100-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color1" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab3" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(200, 299, 3)" :key="'front200-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color2" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab4" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(300, 399, 3)" :key="'front300-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color3" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab5" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(400, 499, 3)" :key="'front400-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color4" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab6" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(500, 599, 3)" :key="'front500-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color5" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab7" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(600, 699, 3)" :key="'front600-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color6" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab8" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(700, 799, 3)" :key="'front700-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color7" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab9" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(800, 899, 3)" :key="'front800-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color8" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

          <div id="fronttab10" class="tab-pane animated fadeIn" >
            <div class="row">
              <div class="column" v-for="(num, index) in createArray(900, 999, 3)" :key="'front900-' + index">
                <button type="button" :ref="'front_' + num" class="btn btn-block btn-default bet-number-tile color9" @click="addCart( num, 'front', $event)"> {{ num }} </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div> 
                            
<div class="row m-t-md" id="boxdown" ref="boxdown" v-show="!downIsHidden">
  <div class="col-xs-12">
    <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div>
    <hr class="m-t-none m-b-none"> 
    <div class="row">
  <div class="col-xs-12">
    <div class="down-inline-toolbar">
      <div class="down-inline-group">
        <strong class="down-inline-label">19 ประตู</strong>
        <div class="down-inline-buttons">
          <button type="button" @click="slide19goal(0, $event)" class="btn btn-default btn-sm">0</button>
          <button type="button" @click="slide19goal(1, $event)" class="btn btn-default btn-sm">1</button>
          <button type="button" @click="slide19goal(2, $event)" class="btn btn-default btn-sm">2</button>
          <button type="button" @click="slide19goal(3, $event)" class="btn btn-default btn-sm">3</button>
          <button type="button" @click="slide19goal(4, $event)" class="btn btn-default btn-sm">4</button>
          <button type="button" @click="slide19goal(5, $event)" class="btn btn-default btn-sm">5</button>
          <button type="button" @click="slide19goal(6, $event)" class="btn btn-default btn-sm">6</button>
          <button type="button" @click="slide19goal(7, $event)" class="btn btn-default btn-sm">7</button>
          <button type="button" @click="slide19goal(8, $event)" class="btn btn-default btn-sm">8</button>
          <button type="button" @click="slide19goal(9, $event)" class="btn btn-default btn-sm">9</button>
      </div>
    </div>

      <div class="down-inline-group">
        <strong class="down-inline-label">รูดหน้า</strong>
        <div class="down-inline-buttons">
          <button type="button" @click="slideFront(0, $event)" class="btn btn-default btn-sm">0</button>
          <button type="button" @click="slideFront(1, $event)" class="btn btn-default btn-sm">1</button>
          <button type="button" @click="slideFront(2, $event)" class="btn btn-default btn-sm">2</button>
          <button type="button" @click="slideFront(3, $event)" class="btn btn-default btn-sm">3</button>
          <button type="button" @click="slideFront(4, $event)" class="btn btn-default btn-sm">4</button>
          <button type="button" @click="slideFront(5, $event)" class="btn btn-default btn-sm">5</button>
          <button type="button" @click="slideFront(6, $event)" class="btn btn-default btn-sm">6</button>
          <button type="button" @click="slideFront(7, $event)" class="btn btn-default btn-sm">7</button>
          <button type="button" @click="slideFront(8, $event)" class="btn btn-default btn-sm">8</button>
          <button type="button" @click="slideFront(9, $event)" class="btn btn-default btn-sm">9</button>
      </div>
    </div> 

      <div class="down-inline-group">
        <strong class="down-inline-label">รูดหลัง</strong>
        <div class="down-inline-buttons">
          <button type="button" @click="slideBack(0, $event)" class="btn btn-default btn-sm">0</button>
          <button type="button" @click="slideBack(1, $event)" class="btn btn-default btn-sm">1</button>
          <button type="button" @click="slideBack(2, $event)" class="btn btn-default btn-sm">2</button>
          <button type="button" @click="slideBack(3, $event)" class="btn btn-default btn-sm">3</button>
          <button type="button" @click="slideBack(4, $event)" class="btn btn-default btn-sm">4</button>
          <button type="button" @click="slideBack(5, $event)" class="btn btn-default btn-sm">5</button>
          <button type="button" @click="slideBack(6, $event)" class="btn btn-default btn-sm">6</button>
          <button type="button" @click="slideBack(7, $event)" class="btn btn-default btn-sm">7</button>
          <button type="button" @click="slideBack(8, $event)" class="btn btn-default btn-sm">8</button>
          <button type="button" @click="slideBack(9, $event)" class="btn btn-default btn-sm">9</button>
        </div>
      </div>
      </div>
    </div>
  </div> 
  <p class="m-t-md m-b-none text-center text-danger">
    <strong>โหมดการเล่น 19 ประตู, รูดหน้า และรูดหลัง ระบบการเล่นเลขที่ซ้ำ จะคิดเพียงเลขเดียว (หากต้องการแทงเลขซ้ำ ให้แทงโพยทีละครั้ง)</strong>
  </p> 
  <hr class="m-t-md m-b-md"> 
  <div class="tabbable">
    <div class="tab-content m-t-md">
      <div class="tab-pane animated fadeIn active in">
        <div class="row">

          <div class="column" v-for="(num, index) in createArray(0, 9, 2)" :key="'down0-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color0" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(10, 19, 2)" :key="'down1-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color1" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(20, 29, 2)" :key="'down2-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color2" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(30, 39, 2)" :key="'down3-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color3" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(40, 49, 2)" :key="'down4-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color4" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(50, 59, 2)" :key="'down5-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color5" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(60, 69, 2)" :key="'down6-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color6" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(70, 79, 2)" :key="'down7-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color7" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(80, 89, 2)" :key="'down8-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color8" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>
          <div class="column" v-for="(num, index) in createArray(90, 99, 2)" :key="'down9-' + index">
            <button type="button" :ref="'down_' + num" class="btn btn-block btn-default bet-number-tile color9" @click="addCart( num, 'down', $event)"> {{ num }} </button>
          </div>

        </div>
      </div>
    </div>
  </div></div>
</div> 


<div class="row m-t-md" id="boxhilow" ref="boxhilow" v-show="!hilowIsHidden">
  <div class="col-xs-12">
    <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div>
    <hr class="m-t-none m-b-none">
    <p class="m-t-md m-b-none text-center text-danger"></p>
    <hr class="m-t-none m-b-none">
    <div class="tabbable">
      <div class="tab-content">
        <div class="row" style="padding: 0px 12px;">

          <div class="col-xs-4" v-for="(num, index) in hilowArray" :key="'hilow-' + index">
            <button type="button" :ref="'hilow_' + num" class="btn btn-block btn-default" @click="addCart( num, 'hilow', $event)"> {{ hilowMapping[num] }} </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-t-md" id="boxevenodd" ref="boxevenodd" v-show="!evenoddIsHidden">
  <div class="col-xs-12">
    <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div>
    <hr class="m-t-none m-b-none">
    <p class="m-t-md m-b-none text-center text-danger"></p>
    <hr class="m-t-none m-b-none">
    <div class="tabbable">
      <div class="tab-content">
        <div class="row" style="padding: 0px 12px;">

          <div class="col-xs-6" v-for="(num, index) in evenoddArray" :key="'evenodd-' + index">
            <button type="button" :ref="'evenodd_' + num" class="btn btn-block btn-default" @click="addCart( num, 'evenodd', $event)"> {{ evenoddMapping[num] }} </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


<div class="row m-t-md" id="boxrunning" ref="boxrunning" v-show="!runningIsHidden">
  <div class="col-xs-12">
    <div v-bind:class="{ 'overlay-disable': numIsDisable }"></div> 
    <div class="tabbable">
      <div class="tab-content">
        <div class="row" style="padding: 0px 12px;">

          <div class="column-78" v-for="(num, index) in createArray(0, 9, 1)" :key="'running-' + index">
            <button type="button" :ref="'running_' + num" class="btn btn-block btn-default" @click="addCart( num, 'running', $event)"> {{ num }} </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="row m-t-md" >
  <div class="col-xs-12">
    <div class="col-xs-12 m-t-md" v-if="calculateBetSize > 0">
        <strong style="float: right" >จำนวนเงินทั้งหมด : {{ formatMoney(calculateBetValue) }} </strong>
    </div> 

    <div class="col-xs-6 col-md-3 m-t-md" style="float: right" v-if="calculateBetSize > 0">
      <button type="button" class="btn btn-danger btn-block" @click="deleteAllItems">ล้างข้อมูล</button>
    </div>
    <div class="col-xs-6 col-md-3 m-t-md" style="float: right" v-if="calculateBetSize > 0">
      <a href="/yeekee#modal-confirm-checkout" data-toggle="modal" class="btn btn-primary btn-block" :disabled="isDisabled" v-if="!isDisabled">แทงพนัน</a>
      <a href="" align="right" data-toggle="modal" class="btn btn-primary btn-block" :disabled="isDisabled" v-if="isDisabled">แทงพนัน</a>
    </div> 
  </div>
</div>

</div></div>
                </div> 

                <div id="cart-item-list" class="col-md-3 bet-side-column">
<div class="ibox bet-cart-card"><div class="ibox-title bet-cart-card__title">
  <h5>รายการแทง</h5>
  <a href="/govhome#number-sets-modal" data-toggle="modal" class="btn btn-warning pull-right btn-sm bet-cart-card__shortcut" @click="loadUserNumber">เลขชุด / ดึงโพย</a>
</div>
<div class="ibox-content bet-cart-card__content">

                    <div class="row">
                      <div class="col-xs-12 m-t-sm text-center" v-if="calculateBetSize">
                        <div class="input-group">
                          <input type="text" placeholder="" maxlength="5" class="form-control money" v-model="sameBetValue" @keypress="onlyNumber" >
                          <span class="input-group-btn">
                            <button class="pull-right btn btn-secondary" @click="setAllSamePrice(sameBetValue)">เดิมพันราคาเท่ากัน</button>
                          </span>
                        </div>
                        <hr class="m-t-none m-b-md"> 
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-xs-12 m-t-sm text-center" v-if="calculateBetSize > 10">
                        <a href="#summarybottom" class="btn btn-primary btn-block" >ดูสรุปยอดแทงด้านล่าง</a>
                        <hr class="m-t-none m-b-md"> 
                      </div>
                      <div class="col-xs-12 m-t-sm text-center" v-if="calculateBetSize < 1">
                        <strong>ยังไม่มีรายการแทง</strong>
                      </div>

                      <!-- cart items -->

                      <div class="col-xs-12 m-b-xs" v-if="threetopCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.threetop }}</h4> 
                        <form class="form-inline" v-for="(item, index) in threetopCart" :key="'threetopCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber">
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="threemixCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.threemix }}</h4> 
                        <form class="form-inline" v-for="(item, index) in threemixCart" :key="'threemixCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="threefrontCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.threefront }}</h4> 
                        <form class="form-inline" v-for="(item, index) in threefrontCart" :key="'threefrontCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="threedownCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.threedown }}</h4> 
                        <form class="form-inline" v-for="(item, index) in threedownCart" :key="'threedownCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="twotopCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.twotop }}</h4> 
                        <form class="form-inline" v-for="(item, index) in twotopCart" :key="'twotopCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="twodownCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.twodown }}</h4> 
                        <form class="form-inline" v-for="(item, index) in twodownCart" :key="'twodownCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="runtopCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.runtop }}</h4> 
                        <form class="form-inline" v-for="(item, index) in runtopCart" :key="'runtopCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="rundownCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ bettypeTextMapping.rundown }}</h4> 
                        <form class="form-inline" v-for="(item, index) in rundownCart" :key="'rundownCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ item.number }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="hibetCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ hashhibet.text }}</h4> 
                        <form class="form-inline" v-for="(item, index) in hibetCart" :key="'hibetCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ hilowMapping[item.number] }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="lowbetCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ hashlowbet.text }}</h4> 
                        <form class="form-inline" v-for="(item, index) in lowbetCart" :key="'lowbetCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ hilowMapping[item.number] }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="evenbetCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ hashevenbet.text }}</h4> 
                        <form class="form-inline" v-for="(item, index) in evenbetCart" :key="'evenbetCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ evenoddMapping[item.number] }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-xs-12 m-b-xs" v-if="oddbetCart.length">
                        <h4 class="m-t-none m-b-xs" >{{ hashoddbet.text }}</h4> 
                        <form class="form-inline" v-for="(item, index) in oddbetCart" :key="'oddbetCart-' + index">
                          <div class="row">
                            <div class="col-xs-12 m-t-none m-b-xs">
                              <div class="input-group">
                                <span class="input-group-addon">{{ evenoddMapping[item.number] }}</span> 
                                <input type="tel" placeholder="ระบุจำนวนเงิน" class="form-control" :value="formatMoney(item.betvalue)" @change="calculateWinPrice(index, item.type, $event)" @keypress="onlyNumber"> 
                                <span class="input-group-btn">
                                  <button type="button" class="btn m-t-none m-b-none btn-default" > ชนะ : {{ formatMoney(item.winprice) }}</button> 
                                  <button type="button" class="btn btn-danger m-t-none m-b-none" @click="deleteItems(index, item.type, $event)"><i class="fa fa-times"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>

                      <!-- end cart items -->


                      <div class="col-xs-12 m-t-md" v-if="isDisabled">
                        <hr class="m-t-none m-b-md">
                        <span data-v-2eaffcc2="" style="background-color: rgb(255, 0, 0);font-size: 24px;color: #fff;">ไม่สามารถแทงเกินวงเงินได้ กรุณาตรวจสอบรายการแทง</span>
                      </div> 

                      <div class="col-xs-12 m-t-md" v-if="calculateBetSize > 0">
                        <hr class="m-t-none m-b-md"> 
                        <strong>จำนวนเงินทั้งหมด : {{ formatMoney(calculateBetValue) }} </strong>
                      </div> 

                      <div id="summarybottom" class="col-xs-6 col-md-6 m-t-md" v-if="calculateBetSize > 0">
                        <a href="/govhome#modal-confirm-checkout" data-toggle="modal" class="btn btn-primary btn-block" :disabled="isDisabled" v-if="!isDisabled">แทงพนัน</a>
                        <a href="" data-toggle="modal" class="btn btn-primary btn-block" :disabled="isDisabled" v-if="isDisabled">แทงพนัน</a>
                      </div> 

                      <div class="col-xs-6 col-md-6 m-t-md" v-if="calculateBetSize > 0">
                        <button type="button" class="btn btn-danger btn-block" @click="deleteAllItems">ล้างข้อมูล</button>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="ibox float-e-margins">
                      <div class="ibox-title">
                        <h5>เงื่อนไขการแทง</h5>
                      </div> 
                      <div class="ibox-content">
                        <div class="row">
                          <div class="col-xs-12" v-if="!upIsHidden">
                          <h4 class="no-margins">
                          สามตัวบน
                          </h4>
                          แทงขั้นต่ำต่อครั้ง : 1 <br>
                          แทงสูงสุดต่อครั้ง : 500 <br>
                          แทงสูงสุดต่อเลข : 1,000 <br> 
                          <hr class="m-t-sm m-b-sm">
                        </div>
                        <div class="col-xs-12" v-if="!upIsHidden">
                          <h4 class="no-margins">
                            สามตัวโต๊ด
                          </h4>
                          แทงขั้นต่ำต่อครั้ง : 1 <br>
                          แทงสูงสุดต่อครั้ง : 500 <br>
                          แทงสูงสุดต่อเลข : 2,000 <br> 
                          <hr class="m-t-sm m-b-sm">
                        </div>
                        <div class="col-xs-12" v-if="!frontIsHidden">
                        <h4 class="no-margins">
                          สามตัวหน้า
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 1 <br>
                      แทงสูงสุดต่อครั้ง : 500 <br>
                      แทงสูงสุดต่อเลข : 2,500 <br> <hr class="m-t-sm m-b-sm"></div>
                      <div class="col-xs-12" v-if="!frontIsHidden">
                      <h4 class="no-margins">
                          สามตัวล่าง
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 1 <br>
                      แทงสูงสุดต่อครั้ง : 500 <br>
                      แทงสูงสุดต่อเลข : 2,500 <br> <hr class="m-t-sm m-b-sm"></div>
                      <div class="col-xs-12" v-if="!downIsHidden">
                      <h4 class="no-margins">
                          สองตัวบน
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 1 <br>
                      แทงสูงสุดต่อครั้ง : 1,000 <br>
                      แทงสูงสุดต่อเลข : 5,000 <br> <hr class="m-t-sm m-b-sm"></div>
                      <div class="col-xs-12" v-if="!downIsHidden">
                      <h4 class="no-margins">
                          สองตัวล่าง
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 1 <br>
                      แทงสูงสุดต่อครั้ง : 1,000 <br>
                      แทงสูงสุดต่อเลข : 5,000 <br> <hr class="m-t-sm m-b-sm"></div>
                      <div class="col-xs-12" v-if="!runningIsHidden">
                      <h4 class="no-margins">
                          วิ่งสามตัวท้ายบน
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>

                      <div class="col-xs-12" v-if="!runningIsHidden">
                      <h4 class="no-margins">
                          วิ่งสองตัวล่าง
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>


                      <div class="col-xs-12" v-if="!hilowIsHidden">
                      <h4 class="no-margins">
                          สูง
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>

                      <div class="col-xs-12" v-if="!hilowIsHidden">
                      <h4 class="no-margins">
                          ต่ำ
                      </h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>


                      <div class="col-xs-12" v-if="!evenoddIsHidden">
                      <h4 class="no-margins">คู่</h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>

                      <div class="col-xs-12" v-if="!evenoddIsHidden">
                      <h4 class="no-margins">คี่</h4>
                      แทงขั้นต่ำต่อครั้ง : 5 <br>
                      แทงสูงสุดต่อครั้ง : 10,000 <br>
                      แทงสูงสุดต่อเลข : 100,000 <br> <hr class="m-t-sm m-b-sm"></div>

                      </div></div></div></div></div>


<div id="number-sets-modal"  role="dialog" aria-hidden="true" class="modal inmodal">
  <div class="modal-dialog">
    <div class="modal-content animated fadeIn">
      <div class="modal-header">
        <button type="button" ref="closeUserNumber" data-dismiss="modal" class="close">
          <span aria-hidden="true">×</span>
          <span class="sr-only">Close</span>
        </button> 
        <h4 class="modal-title">เลขชุด / ดึงโพย</h4>
      </div>
      <div class="modal-body p-sm border-bottom">
        <div class="tabs-container">
          <ul class="nav nav-tabs">
            <li class="active">
              <a data-toggle="tab" href="#nbs-1"><i class="fa fa-list-ol"></i>เลือกเลขชุด</a>
            </li> 
            <li>
              <a data-toggle="tab" href="#nbs-2" @click="loadOrderHistory"><i class="fa fa-list"></i>ดึงโพย</a>
            </li>
          </ul> 
          <div class="tab-content">
            <div id="nbs-1" class="tab-pane tab-numbersets active">
              <div class="panel-body">
                <div class="text-center">
                <router-link :to="{name: 'numberset'}" class="btn btn-primary" target= '_blank'><i class='fa fa-cogs'></i> จัดการเลขชุด</router-link>
                <router-link :to="{name: 'addnumber'}" class="btn btn-primary" target= '_blank'><i class='fa fa-plus'></i> สร้างเลขชุด</router-link>
                <hr class="m-b-xs">
              </div>

              <data-tables :data="userNumberSet" :pagination-props="{ pageSizes: [10, 25, 50, 100] }" :table-props="tableProps">
                <el-table-column prop="name" label="ชื่อเลขชุด" width="auto" >
                </el-table-column>

                <el-table-column prop="created_at" label="วันที่สร้าง" width="auto">
                    <template slot-scope="scope">
                      <div>{{ formatDate(scope.row.created_at) }} </div>
                    </template>
                </el-table-column>

                <el-table-column prop="select" label="เลือก" width="auto" >
                  <template slot-scope="scope">
                    <a class="btn btn-primary btn-sm" @click="selectNumber(scope.row.id)">เลือก</a>
                  </template>
                </el-table-column>
              </data-tables>

          </div>
        </div>

        <div id="nbs-2" class="tab-pane tab-numbersets">
          <div class="panel-body">

              <data-tables :row-style="{height:'20px'}" :cell-style="{padding:'0px'}" style="font-size: 10px" :data="orderHistoryData" :pagination-props="{ pageSizes: [10, 25, 50, 100] }" :table-props="tableProps">
                <el-table-column prop="oh_ordnum" label="เลขที่รายการ" width="auto">
                    <template slot-scope="scope">
                      #{{scope.row.oh_ordnum}}
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="งวดที่" width="auto">
                </el-table-column>
                <el-table-column prop="created_at" label="วันที่ / เวลา" width="auto">
                    <template slot-scope="scope">
                      <div>{{ formatDate(scope.row.created_at) }} </div>
                    </template>
                </el-table-column>
                <el-table-column prop="edit" label="เลือก" width="80" >
                  <template slot-scope="scope">
                    <a class="btn btn-primary btn-sm" @click="selectOrder(scope.row.id)">เลือก</a>
                  </template>
                </el-table-column>
              </data-tables>

          </div>
        </div>

      </div>
    </div>
  </div>
</div></div></div>


<div id="modal-confirm-checkout"  role="dialog" aria-hidden="true" class="modal inmodal">
  <div class="modal-dialog">
    <div class="modal-content animated fadeIn">
      <div class="modal-header" style="padding-bottom: 15px;">
        <button type="button" data-dismiss="modal" class="close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button> <h4 class="modal-title">ดูโพยอีกครั้งก่อนยืนยันการแทงพนัน</h4> <small class="font-bold">{{ gove_round_data.description }}</small></div> 
<div class="text-center p-sm">
  <div class="row">
    <div class="col-xs-6">
      <!-- <button type="button"  data-dismiss="modal" @click="showCheckoutSuccess" class="btn btn-primary btn-block btn-lg"><i class="fa fa-check"></i> ส่งโพย</button> -->
      <button type="button" data-dismiss="modal" @click.once="createOrderhead" class="btn btn-primary btn-block btn-lg" :key="doubleClickKey"><i class="fa fa-check"></i> ส่งโพย</button>
    </div> 
    <div class="col-xs-6">
      <button type="button" data-dismiss="modal" class="btn btn-danger btn-block btn-lg">ยกเลิก</button>
    </div>
  </div>
</div> 


<!-- summarize item -->

<div class="col-xs-12 m-t-sm" v-if="threetopCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.threetop }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in threetopCart" :key="'threetop-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="threemixCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.threemix }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in threemixCart" :key="'threemix-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="threefrontCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.threefront }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in threefrontCart" :key="'threefront-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="threedownCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.threedown }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in threedownCart" :key="'threedown-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="twotopCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.twotop }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in twotopCart" :key="'twotop-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="twodownCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.twodown }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in twodownCart" :key="'twodown-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="runtopCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.runtop }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in runtopCart" :key="'runtop-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="rundownCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ bettypeTextMapping.rundown }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in rundownCart" :key="'rundown-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทงเลข {{ item.number }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="hibetCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ hashhibet.text }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in hibetCart" :key="'hibet-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทง {{ hilowMapping[item.number] }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="lowbetCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ hashlowbet.text }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in lowbetCart" :key="'lowbet-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทง {{ hilowMapping[item.number] }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="evenbetCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ hashevenbet.text }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in evenbetCart" :key="'evenbet-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทง {{ evenoddMapping[item.number] }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<div class="col-xs-12 m-t-sm" v-if="oddbetCart.length">
  <h4 class="m-t-none m-b-xs pull-left">{{ hashoddbet.text }}</h4> 
  <h4 class="m-t-none m-b-xs pull-right">ราคา</h4> 
  <div class="clearfix"></div> 
  <div class="row" v-for="(item, index) in oddbetCart" :key="'oddbet-cf-' + index">
    <div class="col-xs-6 m-t-none m-b-xs">แทง {{ evenoddMapping[item.number] }}</div> 
    <div class="col-xs-6 m-t-none m-b-xs text-right">{{ formatMoney(item.betvalue ) }}</div>
  </div> 
  <hr class="m-t-xs m-b-none">
</div>

<!-- end summarize item -->

<div class="col-xs-12 text-right m-b-sm m-t-sm">
  <strong>รวม :</strong> <strong>{{ formatMoney(calculateBetValue) }}</strong>
</div> 

<div class="p-sm border-top text-center">
  <div class="row">
    <div class="col-xs-6">
      <!-- <button type="button" data-dismiss="modal" @click="showCheckoutSuccess" class="btn btn-primary btn-block btn-lg"><i class="fa fa-check"></i> ส่งโพย</button> -->
      <button type="button" data-dismiss="modal" @click.once="createOrderhead" class="btn btn-primary btn-block btn-lg" :key="doubleClickKey"><i class="fa fa-check"></i> ส่งโพย</button>

    </div> 
    <div class="col-xs-6">
      <button type="button" data-dismiss="modal" class="btn btn-danger btn-block btn-lg">ยกเลิก</button>
    </div>
  </div>
</div>
</div></div></div>


<div id="modal-checkout-success" ref="modalcheckoutsuccess"  role="dialog" aria-hidden="true" class="modal inmodal" @click="closeOutsideModal">
  <div class="modal-dialog">
  <div class="modal-content animated fadeIn">
    <div class="modal-header">
      <h1><i class="fa fa-check text-navy" style="font-size: 60px;"></i></h1> 
      <h4 class="modal-title">ระบบได้ทำการส่งโพยของท่านเรียบร้อยแล้ว</h4>
    </div> 
    <div class="modal-body p-sm border-bottom">
      <h3 class="text-left">โพยเลขที่ #{{ orderNumber }}</h3>
      <h3 class="text-left m-b-none">{{ gove_round_data.description }}</h3></div> 

      <div class="p-sm text-center">
        <div class="row">
          <div class="col-xs-6">
            <!-- <a type="button" href="/transaction" class="btn btn-primary btn-block btn-lg"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</a> -->
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-block btn-lg" @click="redirectTransaction"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</button>
          </div> 
          <div class="col-xs-6">
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-block btn-lg" @click="continueBet"><i class="fa fa-fw fa-sign-in"></i> แทงต่อ</button>
          </div>
        </div>
      </div> 

      <!-- summarize success items -->

      <div class="col-xs-12 m-t-sm" v-if="processItems['threetop'] && processItems['threetop'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.threetop }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['threetop']" :key="'threetop-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['threemix'] && processItems['threemix'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.threemix }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['threemix']" :key="'threemix-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['threefront'] && processItems['threefront'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.threefront }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['threefront']" :key="'threefront-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['threedown'] && processItems['threedown'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.threedown }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['threedown']" :key="'threedown-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['twotop'] && processItems['twotop'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.twotop }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['twotop']" :key="'twotop-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['twodown'] && processItems['twodown'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.twodown }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['twodown']" :key="'twodown-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['runtop'] && processItems['runtop'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.runtop }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['runtop']" :key="'runtop-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['rundown'] && processItems['rundown'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ bettypeTextMapping.rundown }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['rundown']" :key="'rundown-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทงเลข {{ item.number }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div>


      <div class="col-xs-12 m-t-sm" v-if="processItems['hibet'] && processItems['hibet'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ hashhibet.text }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['hibet']" :key="'hibet-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทง {{ hilowMapping[item.number] }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['lowbet'] && processItems['lowbet'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ hashlowbet.text }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['lowbet']" :key="'lowbet-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทง {{ hilowMapping[item.number] }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 


      <div class="col-xs-12 m-t-sm" v-if="processItems['evenbet'] && processItems['evenbet'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ hashevenbet.text }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['evenbet']" :key="'evenbet-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทง {{ evenoddMapping[item.number] }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 

      <div class="col-xs-12 m-t-sm" v-if="processItems['oddbet'] && processItems['oddbet'].length">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">{{ hashoddbet.text }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">แทง</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">สำเร็จ</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right">ล้มเหลว</h4>
        <div class="clearfix"></div> 
      </div>
      <div class="col-xs-12 m-t-sm" v-for="(item, index) in processItems['oddbet']" :key="'oddbet-' + index">
        <div class="m-t-none m-b-xs col-xs-3 text-left">แทง {{ evenoddMapping[item.number] }}</div> 
        <div class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(item.bet_value ) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(item.successResult) }}</div>
        <div class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(item.failResult) }}</div>
      </div> 


      <!-- end of summarize success items -->

      <div class="col-xs-12 m-t-sm">
        <hr class="m-t-xs m-b-none">
        <h4 class="m-t-none m-b-xs col-xs-3 text-left">รวม</h4> 
        <h4 class="m-t-none m-b-xs col-xs-3 text-center">{{ formatMoney(calculateBetValue) }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-center" style="color: blue;">{{ formatMoney(totalSuccessResult) }}</h4>
        <h4 class="m-t-none m-b-xs col-xs-3 text-right text-danger" :class="failClass">{{ formatMoney(totalFailResult) }}</h4>
      </div> 


      <div class="p-sm border-top text-center">
        <div class="row">
          <div class="col-xs-6">

            <!-- <router-link :to="{name: 'account'}" class="btn btn-primary btn-block btn-lg"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</router-link> -->
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-block btn-lg" @click="redirectTransaction"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</button>
            <!-- <a type="button" href="/transaction" class="btn btn-primary btn-block btn-lg"><i class="fa fa-fw fa-list-ol"></i> ดูโพย</a> -->

          </div> 
          <div class="col-xs-6">
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-block btn-lg" @click="continueBet"><i class="fa fa-fw fa-sign-in"></i> แทงต่อ</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="modal-button-confirm"  role="dialog" aria-hidden="true" class="modal inmodal" >
  <div style="width: 400px; margin: 30px auto;">
  <div class="modal-content animated fadeIn">
    <div class="modal-header">
      <button type="button" data-dismiss="modal" class="close">
        <span aria-hidden="true">×</span><span class="sr-only">Close</span>
      </button> 
      <h1><i class="fa fa-exclamation text-navy" style="font-size: 80px;"></i></h1> 
      <h4 class="modal-title">การกดแทงเลขที่เคยแทงแล้ว จะเป็นการยกเลิกการแทงเลขนั้นๆ, คุณต้องการยกเลิก ใช่ หรือ ไม่ใช่ ?</h4>
    </div> 

      <div class="p-sm text-center">
        <div class="row">
          <div class="col-xs-6">

            <button type="button" data-dismiss="modal" class="btn btn-primary" ><i class="fa fa-fw fa-check"></i> ใช่</button>
          </div> 
          <div class="col-xs-6">
            <button type="button" data-dismiss="modal" class="btn btn-primary btn-danger" ><i class="fa fa-fw fa-close"></i> ไม่ใช่</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>



<div style="display: none;">
<a href="#modal-checkout-success" data-toggle="modal" class="btn btn-primary btn-block" ref="clickCheckoutSuccess" ></a>
<a href="#modal-button-confirm" data-toggle="modal" class="btn btn-primary btn-block" ref="clickDeleteButton" ></a>
</div>

        </div>
      </div><!-- /#page-wrapper -->

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

const LOTTO_TYPE_ID = 2 

export default {
    name: 'govhome',
    data () {
        return {

            bettypeTextMapping: {
                threetop: 'สามตัวบน',
                threemix: 'สามตัวโต๊ด',
                threefront: 'สามตัวหน้า',
                threeback: 'สามตัวหลัง',
                threedown: 'สามตัวล่าง', //TODO: not implement yet
                twotop: 'สองตัวบน',
                twodown: 'สองตัวล่าง',
                runtop: 'วิ่งบน',
                rundown: 'วิ่งล่าง',
                hibet: "สูง",
                lowbet: "ต่ำ",
                evenbet: "คู่",
                oddbet: "คี่"
            },

            bettypeCodeMapping: {
                threetop: '4',
                threemix: '1',
                threefront: '2',
                threeback: '3',
                threedown: '5',
                twotop: '6',
                twodown: '7',
                runtop: '8',
                rundown: '9',
                hibet: "10",
                lowbet: "11",
                evenbet: "12",
                oddbet: "13"
            },

            bettypeRateMapping: {
                threetop: 850,
                threemix: 120,
                threefront: 450,
                threeback: 450,
                threedown: 450,
                twotop: 90,
                twodown: 90,
                runtop: '3.20',
                rundown: '4.20',
                hibet: "2",
                lowbet: "2",
                evenbet: "2",
                oddbet: "2"
            },

            bettypeDiscountMapping: {
                threetop: 0,
                threemix: 0,
                threefront: 0,
                threeback: 0,
                threedown: 0,
                twotop: 0,
                twodown: 0,
                runtop: 0,
                rundown: 0,
                hibet: 0,
                lowbet: 0,
                evenbet: 0,
                oddbet: 0
            },

            hashthreetop: {
                text: 'สามตัวบน',
                rate: 850,
            },
            hashthreemix: {
                text: 'สามตัวโต๊ด',
                rate: 120,
            },
            hashthreefront: {
                text: 'สามตัวหน้า',
                rate: 450,
            },
            hashthreeback: {
                text: 'สามตัวหลัง',
                rate: 450,
            },
            hashthreedown: {
                text: 'สามตัวล่าง',
                rate: 450,
            },
            hashtwotop: {
                text: 'สองตัวบน',
                rate: 90,
            },
            hashtwodown: {
                text: 'สองตัวล่าง',
                rate: 90,
            },
            hashruntop: {
                text: 'วิ่งบน',
                rate: '3.20',
            },
            hashrundown: {
                text: 'วิ่งล่าง',
                rate: '4.20',
            },
            hashhibet: {
                text: 'สูง',
                rate: '50',
            },
            hashlowbet: {
                text: 'ต่ำ',
                rate: '50',
            },
            hashevenbet: {
                text: 'คู่',
                rate: '50',
            },
            hashoddbet: {
                text: 'คี่',
                rate: '50',
            },

            hilowMapping: {
                '55999': 'สามตัวบน',
                '55599': 'สองตัวบน',
                '55500': 'สองตัวล่าง',
            },
            evenoddMapping: {
                '55559': 'บน',
                '55550': 'ล่าง',
            },

            betvalue: 1,
            defaultBetvalue: 1,
            customBetValue: 1,
            sameBetValue: '',

            ruleIsHidden: false,
            numberIsHidden: true,
            upIsHidden: true,
            frontIsHidden: true,
            downIsHidden: true,
            runningIsHidden: true,
            hilowIsHidden: true,
            evenoddIsHidden: true,


            numIsDisable: true,
            overCredit: false,

            buttthreetopIsActive: false,
            buttthreemixIsActive: false,
            buttthreefrontIsActive: false,
            buttthreedownIsActive: false,
            butttwotopIsActive: false,
            butttwodownIsActive: false,
            buttruntopIsActive: false,
            buttrundownIsActive: false,
            butthibetIsActive: false,
            buttlowbetIsActive: false,
            buttevenbetIsActive: false,
            buttoddbetIsActive: false,

            permutFlag: false,

            betTypes: {},

            defaultCartTypes: [
                'threetopCart',
                'threemixCart',
                'threefrontCart',
                'threedownCart',
                'twotopCart',
                'twodownCart',
                'runtopCart',
                'rundownCart',
                'hibetCart',
                'lowbetCart',
                'evenbetCart',
                'oddbetCart',
            ],

            threetopCart: [],
            threemixCart: [],
            threefrontCart: [],
            threedownCart: [],
            twotopCart: [],
            twodownCart: [],
            runtopCart: [],
            rundownCart: [],
            hibetCart: [],
            lowbetCart: [],
            evenbetCart: [],
            oddbetCart: [],

            orderNumber: 0,
            userCredit: 0,

            defaultNumber: new Array(100),
            productList: [],

            //bet1Style: "background-color: #DCDCDC",
            bet1Style: '',
            bet5Style: '',
            bet25Style: '',
            bet100Style: '',
            bet500Style: '',

            totalSuccessResult: 0,
            totalFailResult: 0,

            totalBetValue: 0,
            totalDiscountResult: 0,
            totalSubValue: 0,

            hilowArray: [ '55999', '55599', '55500' ],
            evenoddArray: [ '55559', '55550' ],

            processItems: {},

            start_time: '',
            close_time: '',
            gove_round_data: {
                description: '',
                expiration_date: '',
            },
            doubleClickKey: 0,

            userNumberSet: [],
            tableProps: {
                border: true,
                stripe: false,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
            },
            orderHistoryData: [],

            bettypeIdMapping: {
                4: 'threetop',
                1: 'threemix',
                // 2: 'threefront',
                // 3: 'threedown',
                // 5: 'threeback', //TODO: not implement yet
                6: 'twotop',
                7: 'twodown',
                8: 'runtop',
                9: 'rundown',
            },

            bettypeCartMapping: {
                4: 'up',
                1: 'up',
                6: 'down',
                7: 'down',
                8: 'running',
                9: 'running',
            },

            overLimitEnable: false,
            overLimitData: {},
            bettypeButtonClassMapping: {
                1: 'btn-danger',
                4: 'btn-harzard',
                6: 'btn-danger',
                7: 'btn-harzard',
                8: 'btn-danger',
                9: 'btn-harzard',
            },
            bettypeClassGroupMapping: {
                1: 4,
                4: 1,
                6: 7,
                7: 6,
                8: 9,
                9: 8,
            },
            orderBettype: {},
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            //orderhead: state => state.orderhead.orderhead,
            //ledger: state => state.ledger.ledger,
            //cartrule: state => state.cartrule.cartrule,
            //betlimit: state => state.betlimit.betlimit,
            round: state => state.round.round,

        }),
        calculateBetSize: function() {
            
            var size = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                let cartsize = this.$data[carttext].length
                //console.log('cartsize:'+ carttext + ' : ' + cartsize)
                size = size + cartsize
            }
            //console.log('betSize:', size)
            return size

        },
        calculateBetValue: function() {
            
            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
            }
            //console.log('betvaluetot: '+ betvaluetot)


            if ( betvaluetot >  this.userCredit) {
                alert('จำนวนเงินที่ท่านแทง เกินเครดิตที่ท่านมี')
            }
            return betvaluetot.toFixed(2)

        },
        isDisabled() {
            var overcredit = false

            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
                
            }
            //console.log('isDisabled', betvaluetot, this.userCredit)
            if ( betvaluetot >  this.userCredit) {
                overcredit = true 
            }
            else {
                overcredit = false
            }
            return overcredit
        },
        failClass() {
            if ( this.totalFailResult > 0 ) {
                return { 'overlimit-text': true }
            }
            return { 'overlimit-text': false }
        },

    },
    mounted () {
    },
    created () {
        this.loadUserBalance()
        this.initWinRateAndDiscount()
        this.loadSpecificRound()

        this.overLimitEnable = process.env.VUE_APP_OVERLIMIT_ENABLE
        this.loadGovOverLimitNumber()
    },
    updated () {
        //this.loadUserBalance()
    },
    methods: {

        async loadSpecificRound () {
            try {

                let round_id = this.$route.params.round

                const response = await this.$store.dispatch('round/getRoundGOVByRoundId', round_id)
                //console.log('async initial loadSpecificRound', response)

                if ( response.id ) {
                    this.close_time = moment(response.expiration_date)
                }
                else {
                    //console.log('ROUND CLOSE REDIRECT TO Lotto')
                    this.$router.push({name: 'lottery',})
                }
                this.gove_round_data = response

                //console.log('close_time', this.close_time, moment(this.close_time).format('DD/MM/YYYY HH:mm:ss'))

                if ( moment().isAfter(this.close_time) ) {
                    this.$router.push({name: 'lottery',})
                    return 
                }

                //assign bet rate
                if ( response.bet_rate ) {
                    this.bettypeRateMapping = response.bet_rate
                }

                //console.log('loadSpecificRound round_data', this.round_data)
                //console.log('loadSpecificRound start end', moment(this.start_time).format('DD/MM/YYYY HH:mm:ss'), moment(this.close_time).format('DD/MM/YYYY HH:mm:ss'))

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        async loadGovOverLimitNumber () {

            if ( !this.overLimitEnable ) {
                return
            }

            try {

                let param = {
                    round: this.$route.params.round,
                    lottotype_id: LOTTO_TYPE_ID,
                }

                const response = await this.$store.dispatch('betlimit/getOverLimitNumber', param)
                //console.log('loadGovOverLimitNumber', response)

                if ( response.length > 0 ) {
                    //console.log('OverLimitNumber', response)
                    this.overLimitData = response[0]
                }

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        generateOverLimitByType(bet_type, isClick) {

            //console.log('generateOverLimitByType', bet_type, isClick)

            if ( !this.overLimitEnable ) {
                return
            }

            let overlimit_data = this.overLimitData

            let number = overlimit_data[bet_type]
            // console.log('overlimit_data', bet_type, number)

            if ( number ) {
                for (let i = 0; i < number.length; i++) {
                    let num = number[i]

                    if ( bet_type == 1 ) {
                        let permutArray = this.permut(num)
                        let unique = permutArray.filter((v, i, a) => a.indexOf(v) === i)
                        //console.log('theemix', num, unique)

                        for (let i = 0; i < unique.length; i++) {
                            if ( isClick ) {
                                this.disableNumber(unique[i], bet_type)
                            }
                            else {
                                this.enableNumber(unique[i], bet_type)
                            }
                        }
                    }
                    else {
                        if ( isClick ) {
                            this.disableNumber(num, bet_type)
                        }
                        else {
                            this.enableNumber(num, bet_type)
                        }
                    }
                }
            }

        },

        disableNumber(num, bet_type) {

            let numtype = this.bettypeCartMapping[bet_type]
            let buttonClass = this.bettypeButtonClassMapping[bet_type]

            let bet_type_same_class = this.bettypeClassGroupMapping[bet_type] 
            let buttonSameGroupClass = this.bettypeButtonClassMapping[bet_type_same_class]

            let ref_num = numtype + '_' + num

            if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains("btn-default") ) {
                // button did not selected
                this.$refs[ref_num][0].classList.remove("btn-default")
                this.$refs[ref_num][0].classList.toggle(buttonClass)
                this.$refs[ref_num][0].disabled = true
            }
            else if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains("btn-primary") ) {
                // button is seclected
                this.$refs[ref_num][0].classList.remove("btn-primary")
                this.$refs[ref_num][0].classList.toggle(buttonClass)
                this.$refs[ref_num][0].disabled = true
            }
            else if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].disabled ) {
                // button is overlimit with another bettype, add our bettype class 
                if ( this.$refs[ref_num][0].classList.contains(buttonSameGroupClass) ) {
                    this.$refs[ref_num][0].classList.toggle(buttonClass)
                }
               
            }
        },

        enableNumber(num, bet_type) {

            let numtype = this.bettypeCartMapping[bet_type]
            let buttonClass = this.bettypeButtonClassMapping[bet_type]

            let bet_type_same_class = this.bettypeClassGroupMapping[bet_type] 
            let buttonSameGroupClass = this.bettypeButtonClassMapping[bet_type_same_class]

            let ref_num = numtype + '_' + num

            // button is overlimit and contain 2 class then remove our class 
            if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains(buttonClass) && this.$refs[ref_num][0].classList.contains(buttonSameGroupClass) ) {
                this.$refs[ref_num][0].classList.remove(buttonClass)
            }
            else if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains(buttonClass) ) {
                //contain our class only, remove calss and set enable ( user click bettype button )
                this.$refs[ref_num][0].classList.remove(buttonClass)
                this.$refs[ref_num][0].classList.toggle("btn-default")
                this.$refs[ref_num][0].disabled = false
            }

        },

        initWinRateAndDiscount() {
            //console.log('params', this.$route.params, LOTTO_TYPE_ID)
            const user_win_disc = this.user.winrateData
            let lottotype_id = LOTTO_TYPE_ID

            for (let k in this.bettypeRateMapping) {
                let bettype_id = this.bettypeCodeMapping[k]

                if ( user_win_disc[lottotype_id] && user_win_disc[lottotype_id][bettype_id] ) {
                    this.bettypeRateMapping[k] = user_win_disc[lottotype_id][bettype_id].pay_rate
                    this.bettypeDiscountMapping[k] = user_win_disc[lottotype_id][bettype_id].discount
                }
            }

        },
        hiddenMethod: function (message, event) {
            // ✅ กัน <a href="#"> / hash ทำงานเอง (ช่วยอาการต้องกดซ้ำ ๆ)
            if (event) {
                event.preventDefault()
                event.stopPropagation()
            }

            //clear all button and value
            for (let k in this.betTypes){
                let btext = 'butt' + k + 'IsActive'
                this.$data[btext] = false
            }
            this.betTypes = {}

            // ✅ default: ซ่อนทุกโซน แล้วค่อยเปิดเฉพาะที่ต้องการ
            this.ruleIsHidden = true
            this.numberIsHidden = true
            this.upIsHidden = true
            this.frontIsHidden = true
            this.downIsHidden = true
            this.runningIsHidden = true
            this.hilowIsHidden = true
            this.evenoddIsHidden = true

            // --- rule/result ---
            if (message === 'rule' || message === 'result') {
                this.ruleIsHidden = false
                this.numberIsHidden = true
                return
            }

            // --- numbers area ---
            this.ruleIsHidden = true
            this.numberIsHidden = false
                
            if (message === 'threetop') {
                this.upIsHidden = false
            } else if (message === 'threefront') {
                this.frontIsHidden = false
            } else if (message === 'twodown') {
                this.downIsHidden = false
            } else if (message === 'running') {
                this.runningIsHidden = false
            } else if (message === 'hilow') {
                this.hilowIsHidden = false
            } else if (message === 'evenodd') {
                this.evenoddIsHidden = false
            }
        },
        numClickMethod: function (type, event) {
            if (event) event.preventDefault()
            this.numIsDisable = false

            //console.log('userCredit', this.userCredit)
            // active/deactive button
            let butttext = 'butt' + type + 'IsActive'
            //alert(butttext)
            this.$data[butttext] = !this.$data[butttext]

            this.generateOverLimitByType( this.bettypeCodeMapping[type], this.$data[butttext] )

            // keep rate
            //var key = 'hash' + type
            //alert(key)
            if ( this.$data[butttext] ) {
                //this.betTypes[type] = { type: type, text: this.$data[key].text, rate: this.$data[key].rate }
                this.betTypes[type] = { 
                    type: type,
                    text: this.bettypeTextMapping[type],
                    rate: this.bettypeRateMapping[type],
                    disc: this.bettypeDiscountMapping[type]
                }
                
            }
            else {
                delete this.betTypes[type]
            }
            //console.log(type, this.betTypes[type])

            //console.log('numClickMethod betTotal: ', this.betTotal())

        },
        addCart: function (num, numtype, event) {
            if (event) event.preventDefault()

            if ( this.betvalue < 1 ) {
                alert('จำนวนเงินที่ท่านแทง ไม่สามารถแทงได้')
                return
            }

            if ( this.permutFlag && ( numtype === 'up' || numtype === 'front' || numtype === 'down' ) ) {
                //console.log('num', num)
                let permutArray = this.permut(num)
                //console.log('permutArray', num, permutArray)

                let unique = permutArray.filter((v, i, a) => a.indexOf(v) === i)
                //console.log('unique', num, unique)

                for (let i = 0; i < unique.length; i++) {
                    this.pushItemToCart(unique[i], numtype, event)
                }
            }
            else {
                this.pushItemToCart(num, numtype, event)
            }
        },

        async pushItemToCart(num, numtype, event) {
            //console.log('pushItemToCart', num, numtype)
            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot =
                        parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
            }

            // protect over credit
            betvaluetot = betvaluetot + 1

            if (betvaluetot <= this.userCredit) {
                this.numIsDisable = false
                for (let key in this.betTypes) {
                    //console.log('addcart ', key, this.betTypes[key])
                    let winprice = parseFloat(this.betTypes[key].rate) * this.betvalue

                    var carttext = key + "Cart"

                    // check if num is the same existing number then update betvalue
                    // not support ie
                    let objIndex = this.$data[carttext].findIndex(
                        obj => obj.number === num
                    )
                    //console.log('addCart objIndex', objIndex)

                    if (objIndex > -1) {
                        //let r = confirm('การกดแทงเลขที่เคยแทงแล้ว จะเป็นการยกเลิกการแทงเลขนั้นๆ, คุณต้องการยกเลิก ใช่ หรือ ไม่?')
                        //if (r == true) { this.deleteItems(objIndex, key) }
                        this.deleteItems(objIndex, key)
                    } else {

                        let ref_num = numtype + '_' + num
                        //console.log('add cart', ref_num, this.$refs[ref_num])

                        if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains("btn-default") ) {
                            this.$refs[ref_num][0].classList.remove("btn-default")
                            this.$refs[ref_num][0].classList.toggle("btn-primary")
                        }

                        // new number push to array
                        this.$data[carttext].push( { 
                            number: num,
                            type: this.betTypes[key].type,
                            text: this.betTypes[key].text,
                            betvalue: this.betvalue,
                            winprice: winprice.toFixed(2),
                            rate: this.betTypes[key].rate,
                            ref_num: ref_num,
                            successResult: 0,
                            failResult: 0,
                        } )
                    }
                }

            }
            else {
                if ( this.numIsDisable == false ) {
                    alert('ไม่สามารถแทงได้ เกินวงเงิน')
                    this.numIsDisable = true
                }
            }
        },

        async getTotalNumberPerRound(numberData) {
            console.log("numberData", numberData)
            try {
                const responseCreate = await this.$store.dispatch(
                    "orderhead/getTotalNumberLimit",
                    numberData
                )
                //console.log('getTotalNumberPerRound', responseCreate)

                let total_betvalue = 0
                if (responseCreate.length) {
                    total_betvalue = responseCreate[0].total_betvalue || 0
                }
                console.log("total_betvalue", total_betvalue)
                return total_betvalue
            } catch (error) {
                this.$toasted.error("There was an error connecting to the server.")
            }
        },

        calculateWinPrice(index, type, event) {

            if ( !this.validateBetNumber(event.target.value) ) {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง')
                // reset value to 1
                event.target.value = 1
            }

            if (event) event.preventDefault()
            //console.log( 'event.target', event.target )
            var carttext = type + 'Cart'
            this.$data[carttext][index].betvalue = event.target.value
            var rate = ( parseFloat(event.target.value) * parseFloat(this.$data[carttext][index].rate) ) || this.$data[carttext][index].rate
            this.$data[carttext][index].winprice =  rate.toFixed(2)

            //this.betvalue = ( parseFloat(event.target.value) + parseFloat(this.betvalue) )
        },
        deleteItems(index, type, event) {

            var carttext = type + 'Cart'
            //console.log(carttext + '1 ', this.$data[carttext])
            //console.log('deleteItems', this.betvalue, index)
            //this.betvalue = ( parseFloat(this.betvalue) - parseFloat(this.$data[carttext][index].betvalue) )


            //let num = this.$data[carttext][index].number
            let ref_num = this.$data[carttext][index].ref_num

            if ( this.$refs[ref_num][0] && this.$refs[ref_num][0].classList.contains("btn-primary") ) {
                this.$refs[ref_num][0].classList.remove("btn-primary")
                this.$refs[ref_num][0].classList.toggle("btn-default")
            }

            this.$delete(this.$data[carttext], index)
            //console.log(carttext + '2 ', this.$data[carttext])

        },

        deleteAllItems(event) {

            let r = confirm('ยืนยันการล้างข้อมูล ลบชุดตัวเลขที่คุณได้เลือกไว้ทั้งหมด?')
            if (r == true) {
                this.clearAll()
            }

        },

        clearAll() {

            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {

                    //let num = this.$data[carttext][j].number
                    let ref_num = this.$data[carttext][j].ref_num

                    if ( this.$refs[ref_num][0].classList.contains("btn-primary") ) {
                        this.$refs[ref_num][0].classList.remove("btn-primary")
                        this.$refs[ref_num][0].classList.toggle("btn-default")
                    }

                }
                this.$data[carttext] = []
                //console.log('carttext', this.$data[carttext])
                
            }
            //console.log('clearAll setBetValue betvalue: ', this.betvalue)
            //this.setBetValue(this.betvalue)
            this.totalSuccessResult = 0
            this.totalFailResult = 0
            this.orderNumber = 0

            this.$root.$emit('navbar')

        },
        closeOutsideModal(e) {
            //console.log('closeOutsideModal', e)
            this.continueBet()
        },
        continueBet() {
            this.clearAll()

            //console.log('orderBettype', this.orderBettype)
            // generate new overlimit button
            for ( let key in this.orderBettype) {
                this.generateOverLimitByType( key, true )
            }
            this.orderBettype = {}

        },
        showCheckoutSuccess() {
            this.$refs.clickCheckoutSuccess.click()
        },
        showButtonDelete() {
            this.$refs.clickDeleteButton.click()
        },
        redirectTransaction() {
            this.$router.push('/transaction')
        },
        onlyNumber ($event) {
            //console.log($event.keyCode) //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
            if (keyCode < 48 || keyCode > 57) {
                $event.preventDefault()
            }
        },
        validateBetNumber (amount) {
            let rgx = /^[0-9]+$/g
            if ( amount.toString().match(rgx) && amount > 0 ) {
                return 1
            }
            return 
        },
        searchNumber({ type, target }) {

            let filter = target.value
            console.log(filter)

            for (let i = 1; i < 11; i++) {
                let tabtext = 'tab' + i
                console.log('tabtext: ', tabtext)
                let parentdiv = document.getElementById(tabtext)
                console.log(parentdiv)
                let childdiv = parentdiv.getElementsByTagName('div')
                console.log(childdiv.length)

                for (let i = 0; i < childdiv.length; i++) {
                    let b = childdiv[i].getElementsByTagName("button")[0]
                    //console.log(b.innerHTML + ' : ' + filter + ' : ' + b.innerHTML.indexOf(filter))
                    if (b.innerHTML.indexOf(filter) > -1) {
                        childdiv[i].style.display = ""
                        //console.log(b.innerHTML + ' : ' + filter + ' : ' + b.innerHTML.indexOf(filter))
                    } else {
                        childdiv[i].style.display = "none"
                    }
                }

            }

        },

        setCustomBetValue(event) {

            let customBet = event.target.value
            //console.log('customBet', customBet)

            if ( !this.validateBetNumber(customBet) ) {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง')
                // reset value to 1
                customBet = 1
            }

            this.betvalue = customBet
            this.customBetValue = this.betvalue
            //this.setBetValue(customBet, event)

        },

        setAllSamePrice() {
            // console.log('sameBetValue', this.sameBetValue)

            let newSameBet = this.sameBetValue

            if ( !this.validateBetNumber(newSameBet) ) {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง')
                // reset value to 1
                this.sameBetValue = 1
                return
            }

            for (let i = 0; i < this.defaultCartTypes.length; i++) {

                let carttext = this.defaultCartTypes[i]
                //loopItemData:
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    let cart_item = this.$data[carttext][j]

                    this.$data[carttext][j].betvalue = newSameBet
                    let newWinRate =
                        parseFloat(newSameBet) * parseFloat(cart_item.rate)
                    this.$data[carttext][j].winprice = newWinRate
                }
            }

            // reset value
            this.sameBetValue = ''

        },

        async createOrderhead () {

            if ( moment().isAfter(this.close_time) ) {
                this.$toasted.error('ปิดรับแทง.')
                this.$router.push({name: 'lottery',})
                return
            }


            //console.log('createOrderhead setBetValue betvalue: ', this.betvalue)
            //this.setBetValue(this.betvalue)
            this.totalSuccessResult = 0
            this.totalFailResult = 0

            let betvaluetot = this.betTotal()

            let orderData = {
                itemdata: [],
                oh_total: betvaluetot,
                status_id: 1, // pending
                currency_id: 1, //THB
                round: this.$route.params.round, // fix round number
                lottotype_id: LOTTO_TYPE_ID, // fix lotto type 2=GOV
                //oh_ordnum: this.orderNumber,
                comment: '',
                //round_date: round_date,
                //country_id: this.gove_round_data.country_id,
                round_id: this.gove_round_data.id,
                // af_user_id: this.user.parent_user_id || '',
                // af_amt: 0,
                // af_paid: 0,
            }

            let orderTotal = 0

            let allItemData = []
            for (let i = 0; i < this.defaultCartTypes.length; i++) {

                let carttext = this.defaultCartTypes[i]
                //loopItemData:
                for (let j = 0; j < this.$data[carttext].length; j++) {

                    let bettype = this.$data[carttext][j].type
                    let bettype_id = this.bettypeCodeMapping[bettype]

                    let itemData = {
                        oh_id: 0,
                        number: this.$data[carttext][j].number,
                        bet_value: this.$data[carttext][j].betvalue,
                        rate: this.$data[carttext][j].rate,
                        win_price: this.$data[carttext][j].winprice,

                        bettype_id: bettype_id,
                        status_id: 4, // fix complete
                        currency_id: orderData.currency_id,

                        oi_can: 0,
                        oi_rollback: 0,
                        oi_win: 0,

                        bettype: bettype,
                    }
                    //console.log('itemData', itemData)
                    allItemData.push( itemData )
                    this.orderBettype[bettype_id] = 1
                }
            }

            orderData['itemdata'] = allItemData

            let loader = this.$loading.show()

            try {

                //console.log('createOrderhead orderData: ', orderData)

                const responseCreate = await this.$store.dispatch('orderhead/createOrderhead', orderData)
                //console.log('createOrderhead responseCreate: ', responseCreate)

                orderTotal = responseCreate.data.orderTotal

                // orderTotal must have value
                if ( orderTotal > 0 ) {

                    //let insertId = responseCreate.data.id
                    //const orderId = insertId[0]

                    this.processItems = responseCreate.data.resultItems
                    this.totalSuccessResult = responseCreate.data.totalSuccess.toFixed(2)
                    this.totalFailResult = responseCreate.data.totalFail.toFixed(2)
                    this.orderNumber = responseCreate.data.orderNumber

                    this.showCheckoutSuccess()
                }
                else {
                    this.$toasted.error('ไม่สามารถแทงได้ เกินจำนวนลิมิต')
                }
 
            } catch (error) {
                let error_msg = 'There was an error connecting to the server.'
                let response = error.response.data
                if ( response ) {
                    error_msg = response.message
                }
                this.$toasted.error(error_msg)

                if ( response.message == 'INVALID_CREATED_TIME_FOR_ORDER' ) {
                    this.$router.push({name: 'lottery',})
                }
            } finally {
                this.$root.$emit('navbar')
                this.doubleClickKey += 1
                loader.hide()
                await this.loadGovOverLimitNumber()
            }
        },

        betTotal() {
            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
            }
            return betvaluetot
        },
        setBetValue(betvalue, event) {
            //console.log('setBetValue betvalue: ', betvalue)

            this.bet1Style = ''
            this.bet5Style = ''
            this.bet25Style = ''
            this.bet100Style = ''
            this.bet500Style = ''

            //let betref = 'bet' + betvalue + 'Style'
            //console.log(this.$data[betref], betref)
            //this.$data[betref] = "background-color: #DCDCDC"
            //console.log(this.$data[betref])

            //this.betvalue = betvalue
            //this.customBetValue = betvalue

            this.betvalue = parseFloat(this.betvalue) + parseFloat(betvalue)
            this.customBetValue = this.betvalue

        },

        clearBetValue () {
            //console.log('clearBetValue', this.betvalue)
            this.betvalue = 0
            this.customBetValue = 0
        },

        async loadUserBalance () {
            try {
                const response = await this.$store.dispatch('ledger/getUserBalance', this.user.account_id)
                //console.log('GOVHOME response: ', response)
                this.userCredit = response.balance.toFixed(2)
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
                this.$store.dispatch('user/userLogout')
            }
        },

        leftPad(number, targetLength) {
            let output = number + ''
            while (output.length < targetLength) {
                output = '0' + output
            }
            return output
        },

        createArray(first, last, str_len) {
            let arr = []
            for(var i=first; i<=last; i++) {
                let value = this.leftPad(i, str_len)
                arr.push(value.toString())
            }
            //console.log(arr)
            return arr
        },

        setPermutFlag() {
            this.permutFlag = !this.permutFlag
            //console.log('permutFlag', this.permutFlag)
            if ( event.target.classList.contains("btn-default") ) {

                event.target.classList.remove("btn-default")
                event.target.classList.toggle("btn-primary")
            }
            else {
                event.target.classList.remove("btn-primary")
                event.target.classList.toggle("btn-default")
            }
        },

        permut(string) {
            //console.log('permut string', string)
            let results = []

            if (string.length === 1) {
                results.push(string)
                return results
            }

            for (let i = 0; i < string.length; i++) {
                let firstChar = string[i]
                let charsLeft = string.substring(0, i) + string.substring(i + 1)
                let innerPermutations = this.permut(charsLeft)
                for (let j = 0; j < innerPermutations.length; j++) {
                    results.push(firstChar + innerPermutations[j])
                }
            }
            return results
        },


        slideFront(num, event) {

            if ( this.betvalue < 1 ) {
                alert('จำนวนเงินที่ท่านแทง ไม่สามารถแทงได้')
                return
            }

            //console.log('slideFront', num)
            for(var i=0; i<=9; i++) {
                let value = num.toString() + i
                //console.log('slideFront', i, value, event)
                this.addCartSkipDuplicated(value, event)
            }

        },

        slideBack(num, event) {
            //console.log('slideBack', num)

            if ( this.betvalue < 1 ) {
                alert('จำนวนเงินที่ท่านแทง ไม่สามารถแทงได้')
                return
            }

            for(var i=0; i<=9; i++) {
                let value =  i + num.toString()
                //console.log('slideFront', i, value)
                this.addCartSkipDuplicated(value, event)
            }
        },

        slide19goal(num, event) {
            //console.log('slide19goal', num)

            if ( this.betvalue < 1 ) {
                alert('จำนวนเงินที่ท่านแทง ไม่สามารถแทงได้')
                return
            }

            let arr = []
            for(var i=0; i<=9; i++) {
                let front = num.toString() + i
                let back =  i + num.toString()
                arr.push(front, back)
            }

            let unique = arr.filter((v, i, a) => a.indexOf(v) === i)
            for (let i = 0; i < unique.length; i++) {
                this.addCartSkipDuplicated(unique[i], event)
            }

        },

        addCartSkipDuplicated: function (num, event) {
            //if (event) event.preventDefault()

            var betvaluetot = 0
            for (let i = 0; i < this.defaultCartTypes.length; i++) {
                let carttext = this.defaultCartTypes[i]
                for (let j = 0; j < this.$data[carttext].length; j++) {
                    betvaluetot = parseFloat(betvaluetot) + parseFloat(this.$data[carttext][j].betvalue)
                }
            }

            // protect over credit
            betvaluetot = betvaluetot + 1


            if ( betvaluetot <=  this.userCredit) {
                this.numIsDisable = false
                for (let key in this.betTypes){

                    let winprice = parseFloat(this.betTypes[key].rate) * this.betvalue
                    var carttext = key + 'Cart'

                    // check if num is the same existing number then update betvalue
                    // not support ie
                    let objIndex = this.$data[carttext].findIndex((obj => obj.number === num))


                    if ( objIndex > -1 ) {
                        // do nothing
                    }
                    else {
                        // down_00 for 2down only
                        let ref_num = 'down_' + num

                        if ( this.$refs[ref_num][0].classList.contains("btn-default") ) {
                            this.$refs[ref_num][0].classList.remove("btn-default")
                            this.$refs[ref_num][0].classList.toggle("btn-primary")
                        }

                        // new number push to array
                        this.$data[carttext].push( { 
                            number: num,
                            type: this.betTypes[key].type,
                            text: this.betTypes[key].text,
                            betvalue: this.betvalue,
                            winprice: winprice.toFixed(2),
                            rate: this.betTypes[key].rate,
                            ref_num: ref_num,
                            successResult: 0,
                            failResult: 0,
                        } )
                    }
                }

            }
            else {
                if ( this.numIsDisable == false ) {
                    alert('ไม่สามารถแทงได้ เกินวงเงิน')
                    this.numIsDisable = true
                }
            }
        },

        formatDate (value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

        async loadUserNumber () {
            //console.log('loadUserNumber')
            let loader = this.$loading.show()
            try {
                const response = await this.$store.dispatch('usernumber/getAllUsernumber', { order: 'desc', })
                //console.log('async loadUserNumber', response)

                this.userNumberSet = response.result

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                loader.hide()
            }
        },

        async selectNumber (setId) {
            try {
                const response = await this.$store.dispatch('usernumber/getUsernumber', setId)
                //console.log('response: ', response)

                if ( response.length > 0 ) {

                    //clear cart before add number
                    this.clearAll()

                    let copyBetType = Object.assign({}, this.betTypes) 
                    this.clearBetType()

                    for (let i = 0; i < response.length; i++) {
                        let bettype_id = response[i].bettype_id
                        let number = response[i].number

                        let type = this.bettypeIdMapping[bettype_id]

                        //console.log('selectNumber', bettype_id, type, number)

                        this.betTypes[type] = { 
                            type: type,
                            text: this.bettypeTextMapping[type],
                            rate: this.bettypeRateMapping[type],
                            disc: this.bettypeDiscountMapping[type]
                        }

                        //this.numClickMethod(type)

                        let cart_type = this.bettypeCartMapping[bettype_id]
                        this.addCart( number, cart_type)

                        delete this.betTypes[type]
                    }
                    this.betTypes = copyBetType
                    this.$refs.closeUserNumber.click()
                }
                
            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        async loadOrderHistory () {
            let loader = this.$loading.show()
            try {
                const response = await this.$store.dispatch('orderhead/getUsersOrderhead', { order: 'desc', type: 'numberset', limit: 10 })
                //console.log('async loadOrderHistory', response)

                this.orderHistoryData = response.orderData

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            } finally {
                loader.hide()
            }
        },

        async selectOrder (orderId) {
            try {

                const response = await this.$store.dispatch('orderitem/getOrderitem', orderId)
                //console.log('response: ', response, this.betvalue)


                if ( response.length > 0 ) {

                    //clear cart before add number
                    this.clearAll()

                    let copyBetType = Object.assign({}, this.betTypes) 
                    this.clearBetType()

                    let current_betvalue = this.betvalue
                    for (let i = 0; i < response.length; i++) {

                        let bettype_id = response[i].bettype_id
                        let number = response[i].number

                        let type = this.bettypeIdMapping[bettype_id]

                        this.betvalue = response[i].bet_value

                        //console.log('selectNumber', bettype_id, type, number)

                        this.betTypes[type] = { 
                            type: type,
                            text: this.bettypeTextMapping[type],
                            rate: this.bettypeRateMapping[type],
                            disc: this.bettypeDiscountMapping[type]
                        }

                        //this.numClickMethod(type)

                        let cart_type = this.bettypeCartMapping[bettype_id]
                        this.addCart( number, cart_type)

                        delete this.betTypes[type]
                    }
                    this.betvalue = current_betvalue
                    this.betTypes = copyBetType
                    this.$refs.closeUserNumber.click()

                }

                
            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        clearBetType() {
            for (let key in this.betTypes){
                delete this.betTypes[key]
            }
        },

    },
}
</script>

<style scoped>
	body.swal2-shown{overflow-y:hidden}.swal2-container,body.swal2-iosfix{position:fixed;left:0;right:0}.swal2-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;top:0;bottom:0;padding:10px;background-color:transparent;z-index:1060}.swal2-container.swal2-fade{-webkit-transition:background-color .1s;transition:background-color .1s}.swal2-container.swal2-shown{background-color:rgba(0,0,0,.4)}.swal2-modal{background-color:#fff;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;border-radius:5px;box-sizing:border-box;text-align:center;margin:auto;overflow-x:hidden;overflow-y:auto;display:none;position:relative}.swal2-modal:focus{outline:none}.swal2-modal.swal2-loading{overflow-y:hidden}.swal2-modal .swal2-title{color:#595959;font-size:30px;text-align:center;font-weight:600;text-transform:none;position:relative;margin:0 0 .4em;padding:0;display:block}.swal2-modal .swal2-spacer{height:10px;color:transparent;border:0}.swal2-modal .swal2-styled{border:0;border-radius:3px;box-shadow:none;color:#fff;cursor:pointer;font-size:17px;font-weight:500;margin:0 5px;padding:10px 32px}.swal2-modal .swal2-styled:not(.swal2-loading)[disabled]{opacity:.4;cursor:no-drop}.swal2-modal .swal2-styled.swal2-loading{box-sizing:border-box;border:4px solid transparent;border-color:transparent;width:40px;height:40px;padding:0;margin:-2px 30px;vertical-align:top;background-color:transparent!important;color:transparent;cursor:default;border-radius:100%;-webkit-animation:rotate-loading 1.5s linear 0s infinite normal;animation:rotate-loading 1.5s linear 0s infinite normal;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-modal .swal2-styled+.swal2-styled{margin-top:15px}.swal2-modal :not(.swal2-styled).swal2-loading:after{display:inline-block;content:"";margin-left:5px;vertical-align:-1px;height:6px;width:6px;border:3px solid #999;border-right-color:transparent;border-radius:50%;-webkit-animation:rotate-loading 1.5s linear 0s infinite normal;animation:rotate-loading 1.5s linear 0s infinite normal}.swal2-modal .swal2-image{margin:20px auto;max-width:100%}.swal2-modal .swal2-close{font-size:36px;line-height:36px;font-family:serif;position:absolute;top:5px;right:13px;cursor:pointer;color:#ccc;-webkit-transition:color .1s ease;transition:color .1s ease}.swal2-modal .swal2-close:hover{color:#d55}.swal2-modal>.swal2-checkbox,.swal2-modal>.swal2-file,.swal2-modal>.swal2-input,.swal2-modal>.swal2-radio,.swal2-modal>.swal2-select,.swal2-modal>.swal2-textarea{display:none}.swal2-modal .swal2-content{font-size:18px;text-align:center;font-weight:300;position:relative;float:none;margin:0;padding:0;line-height:normal;color:#545454}.swal2-modal .swal2-checkbox,.swal2-modal .swal2-file,.swal2-modal .swal2-input,.swal2-modal .swal2-radio,.swal2-modal .swal2-select,.swal2-modal .swal2-textarea{margin:20px auto}.swal2-modal .swal2-file,.swal2-modal .swal2-input,.swal2-modal .swal2-textarea{width:100%;box-sizing:border-box;border-radius:3px;border:1px solid #d9d9d9;font-size:18px;box-shadow:inset 0 1px 1px rgba(0,0,0,.06);-webkit-transition:border-color box-shadow .3s;transition:border-color box-shadow .3s}.swal2-modal .swal2-file.swal2-inputerror,.swal2-modal .swal2-input.swal2-inputerror,.swal2-modal .swal2-textarea.swal2-inputerror{border-color:#f06e57!important}.swal2-modal .swal2-file:focus,.swal2-modal .swal2-input:focus,.swal2-modal .swal2-textarea:focus{outline:none;box-shadow:0 0 3px #c4e6f5;border:1px solid #b4dbed}.swal2-modal .swal2-file:focus::-webkit-input-placeholder,.swal2-modal .swal2-input:focus::-webkit-input-placeholder,.swal2-modal .swal2-textarea:focus::-webkit-input-placeholder{-webkit-transition:opacity .3s ease .03s;transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file:focus::-moz-placeholder,.swal2-modal .swal2-input:focus::-moz-placeholder,.swal2-modal .swal2-textarea:focus::-moz-placeholder{-webkit-transition:opacity .3s ease .03s;transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file:focus:-ms-input-placeholder,.swal2-modal .swal2-input:focus:-ms-input-placeholder,.swal2-modal .swal2-textarea:focus:-ms-input-placeholder{-webkit-transition:opacity .3s ease .03s;transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file:focus::placeholder,.swal2-modal .swal2-input:focus::placeholder,.swal2-modal .swal2-textarea:focus::placeholder{-webkit-transition:opacity .3s ease .03s;transition:opacity .3s ease .03s;opacity:.8}.swal2-modal .swal2-file::-webkit-input-placeholder,.swal2-modal .swal2-input::-webkit-input-placeholder,.swal2-modal .swal2-textarea::-webkit-input-placeholder{color:#e6e6e6}.swal2-modal .swal2-file::-moz-placeholder,.swal2-modal .swal2-input::-moz-placeholder,.swal2-modal .swal2-textarea::-moz-placeholder{color:#e6e6e6}.swal2-modal .swal2-file:-ms-input-placeholder,.swal2-modal .swal2-input:-ms-input-placeholder,.swal2-modal .swal2-textarea:-ms-input-placeholder{color:#e6e6e6}.swal2-modal .swal2-file::placeholder,.swal2-modal .swal2-input::placeholder,.swal2-modal .swal2-textarea::placeholder{color:#e6e6e6}.swal2-modal .swal2-range input{float:left;width:80%}.swal2-modal .swal2-range output{float:right;width:20%;font-size:20px;font-weight:600;text-align:center}.swal2-modal .swal2-range input,.swal2-modal .swal2-range output{height:43px;line-height:43px;vertical-align:middle;margin:20px auto;padding:0}.swal2-modal .swal2-input{height:43px;padding:0 12px}.swal2-modal .swal2-input[type=number]{max-width:150px}.swal2-modal .swal2-file{font-size:20px}.swal2-modal .swal2-textarea{height:108px;padding:12px}.swal2-modal .swal2-select{color:#545454;font-size:inherit;padding:5px 10px;min-width:40%;max-width:100%}.swal2-modal .swal2-radio{border:0}.swal2-modal .swal2-radio label:not(:first-child){margin-left:20px}.swal2-modal .swal2-radio input,.swal2-modal .swal2-radio span{vertical-align:middle}.swal2-modal .swal2-radio input{margin:0 3px 0 0}.swal2-modal .swal2-checkbox{color:#545454}.swal2-modal .swal2-checkbox input,.swal2-modal .swal2-checkbox span{vertical-align:middle}.swal2-modal .swal2-validationerror{background-color:#f0f0f0;margin:0 -20px;overflow:hidden;padding:10px;color:gray;font-size:16px;font-weight:300;display:none}.swal2-modal .swal2-validationerror:before{content:"!";display:inline-block;width:24px;height:24px;border-radius:50%;background-color:#ea7d7d;color:#fff;line-height:24px;text-align:center;margin-right:10px}@supports (-ms-accelerator:true){.swal2-range input{width:100%!important}.swal2-range output{display:none}}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.swal2-range input{width:100%!important}.swal2-range output{display:none}}.swal2-icon{width:80px;height:80px;border:4px solid transparent;border-radius:50%;margin:20px auto 30px;padding:0;position:relative;box-sizing:content-box;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.swal2-icon.swal2-error{border-color:#f27474}.swal2-icon.swal2-error .x-mark{position:relative;display:block}.swal2-icon.swal2-error .line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal2-icon.swal2-error .line.left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal2-icon.swal2-error .line.right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}.swal2-icon.swal2-warning{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;color:#f8bb86;border-color:#facea8}.swal2-icon.swal2-info,.swal2-icon.swal2-warning{font-size:60px;line-height:80px;text-align:center}.swal2-icon.swal2-info{font-family:Open Sans,sans-serif;color:#3fc3ee;border-color:#9de0f6}.swal2-icon.swal2-question{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;color:#87adbd;border-color:#c9dae1;font-size:60px;line-height:80px;text-align:center}.swal2-icon.swal2-success{border-color:#a5dc86}.swal2-icon.swal2-success:after,.swal2-icon.swal2-success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal2-icon.swal2-success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px}.swal2-icon.swal2-success .placeholder{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal2-icon.swal2-success .fix{width:7px;height:90px;background-color:#fff;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-icon.swal2-success .line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal2-icon.swal2-success .line.tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal2-icon.swal2-success .line.long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal2-progresssteps{font-weight:600;margin:0 0 20px;padding:0}.swal2-progresssteps li{display:inline-block;position:relative}.swal2-progresssteps .swal2-progresscircle{background:#3085d6;border-radius:2em;color:#fff;height:2em;line-height:2em;text-align:center;width:2em;z-index:20}.swal2-progresssteps .swal2-progresscircle:first-child{margin-left:0}.swal2-progresssteps .swal2-progresscircle:last-child{margin-right:0}.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep{background:#3085d6}.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep~.swal2-progresscircle,.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep~.swal2-progressline{background:#add8e6}.swal2-progresssteps .swal2-progressline{background:#3085d6;height:.4em;margin:0 -1px;z-index:10}[class^=swal2]{-webkit-tap-highlight-color:transparent}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(.7);transform:scale(.7)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes hideSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}@keyframes hideSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}}.swal2-show{-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s}.swal2-show.swal2-noanimation{-webkit-animation:none;animation:none}.swal2-hide{-webkit-animation:hideSweetAlert .15s forwards;animation:hideSweetAlert .15s forwards}.swal2-hide.swal2-noanimation{-webkit-animation:none;animation:none}@-webkit-keyframes animate-success-tip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animate-success-tip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animate-success-long{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animate-success-long{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}.animate-success-tip{-webkit-animation:animate-success-tip .75s;animation:animate-success-tip .75s}.animate-success-long{-webkit-animation:animate-success-long .75s;animation:animate-success-long .75s}.swal2-success.animate:after{-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}@-webkit-keyframes animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animate-error-icon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}.animate-error-icon{-webkit-animation:animate-error-icon .5s;animation:animate-error-icon .5s}@-webkit-keyframes animate-x-mark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animate-x-mark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.animate-x-mark{-webkit-animation:animate-x-mark .5s;animation:animate-x-mark .5s}@-webkit-keyframes pulse-warning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulse-warning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.pulse-warning{-webkit-animation:pulse-warning .75s infinite alternate;animation:pulse-warning .75s infinite alternate}@-webkit-keyframes rotate-loading{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate-loading{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}

	.btn-default.focus,.btn-default:focus{background:0 0!important}.tab-pane>.row{padding:0 12px}.ui-modal-mask{z-index:1040}.tab-content{padding-left:0;padding-bottom:0;padding-right:0}.tab-content .column,.tab-content .column-78{float:left;margin-bottom:5px;padding-left:2.5px;padding-right:2.5px}.tab-content .column{width:10%}.tab-content .column-78{width:20%}.fa-check-circle-o{position:absolute;left:15px;top:11px;bottom:0}.animated{transition:.5s}.btn-dark.btn-transparent.active{background-color:rgba(31,34,37,.1)!important;border:1px solid #1f2225!important;color:#1f2225!important}.bet-price{width:100px}.table-responsive{padding:0;margin:0}.modal-body{padding-left:15px;padding-right:15px}.btn-remove-box{position:absolute;top:10px;right:10px}.container-fluid{padding:0}@media only screen and (max-width:600px){.nav.nav-tabs.nav-justified li{float:left;width:10%}.tab-pane .column{width:10%!important}.nav.nav-tabs.nav-justified a,.tab-pane .btn{padding-left:0!important;padding-right:0!important}.tab-pane.tab-numbersets .btn{padding-left:15px!important;padding-right:15px!important}.navbar-form.navbar-right{margin-right:-15px}.navbar-form.navbar-right button{width:100%;margin-top:8px;display:block}.subtype-group .btn{white-space:inherit}}

	.column-main-lotto{float:left;width:33.333%;margin-bottom:5px;padding-left:2.5px;padding-right:2.5px}.column-main-lotto.double-column{width:66.666%}.column-main-lotto.half-viewport{width:50%}.input-group-cart-item .input-group-addon{width:100%!important;padding-top:9px}.input-group-cart-item strong{letter-spacing:10px;padding-left:10px;font-size:18px}.row-current-number{padding:7px 12px;font-size:5vw;text-align:center}@media only screen and (max-width:768px){.navbar-mainlotto{padding:0}.navbar-mainlotto ul li:first-child{border-right:1px solid #e7eaec!important}.row-current-number{font-size:15vw}.navbar-mainlotto li{width:49%;display:inline-block}}

	.responsive-table table {
		border-collapse: collapse;
		border-spacing: 0;
		width: 100%;
		border: 1px solid #ddd;
	}

	.responsive-table th, td {
		text-align: left;
		padding: 8px;
	}

	.image-responsive {
		width: 100%;
		height: auto;
	}

  .nav > li.active {
    border-left: 1px solid white;
  }

  .overlimit-text {
    font-size: 18px;
    font-weight: 1000;
  }

  .bet-page-shell {
  padding: 10px 0 28px;
  background:
    radial-gradient(circle at top left, rgba(42, 110, 107, 0.10), transparent 26%),
    radial-gradient(circle at top right, rgba(186, 211, 210, 0.18), transparent 28%),
    linear-gradient(180deg, #edf4f3 0%, #e7efee 100%);
  min-height: calc(100vh - 80px);
}

.bet-page-container {
  padding: 0 12px 24px;
}

.bet-page-header-wrap {
  margin-bottom: 14px;
}

.bet-hero-card,
.bet-section-card,
.bet-cart-card {
  border: 1px solid rgba(42, 110, 107, 0.18);
  border-radius: 24px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(246,250,250,0.96) 100%);
  box-shadow: 0 18px 40px rgba(26, 79, 75, 0.08);
}

.bet-hero-card > .ibox-title,
.bet-section-card > .ibox-title,
.bet-cart-card > .ibox-title {
  border-bottom: 1px solid rgba(42, 110, 107, 0.14);
  background: linear-gradient(180deg, rgba(249,252,252,0.98) 0%, rgba(241,247,247,0.98) 100%);
}

.bet-hero-card__title {
  padding: 18px 22px 14px;
}

.bet-hero-card__crumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #5f7574;
  margin-bottom: 6px;
}

.bet-hero-card__crumb-link {
  color: #1A4F4B !important;
  font-weight: 600;
}

.bet-hero-card__crumb-sep {
  opacity: 0.55;
}

.bet-hero-card__name {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
  color: #1a2e2d;
}

.bet-hero-card__content {
  background: transparent;
}

.bet-slug-nav {
  margin-bottom: 0;
  border: 0;
  background: transparent;
  min-height: auto;
}

.bet-slug-nav .navbar-collapse {
  padding-left: 10px;
  padding-right: 10px;
}

.bet-slug-nav__list {
  float: none !important;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 16px 18px;
}

.bet-slug-nav__list > li {
  float: none !important;
  margin: 0 !important;
  border: 0 !important;
}

.bet-slug-nav__list > li > a.bet-tab-pill {
  display: block;
  border-radius: 999px !important;
  border: 1px solid #d8872f !important;
  background: linear-gradient(135deg, #f2a23a 0%, #d8831f 100%) !important;
  color: #111 !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  padding: 14px 22px !important;
  min-height: 52px;
  line-height: 1.2;
  transition: all 0.2s ease !important;
}

.bet-slug-nav__list > li.active > a.btn-bet-info,
.bet-slug-nav__list > li > a.btn-bet-info:hover,
.bet-slug-nav__list > li > a.btn-bet-info:focus {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%);
  border-color: transparent;
  color: #fff !important;
}

.bet-main-shell {
  background: transparent;
  box-shadow: none;
  border: 0;
}

.bet-main-column,
.bet-side-column {
  padding-top: 4px;
}

.bet-section-card {
  margin-bottom: 16px;
}

.bet-section-card > .ibox-content {
  padding: 20px 18px;
  background: transparent;
}

.bet-section-card > .ibox-title {
  padding: 16px 18px;
}

.bet-price-toolbar h5,
.bet-cart-card__title h5,
.bet-section-card .ibox-title h5 {
  font-size: 16px;
  font-weight: 700;
  color: #1a2e2d;
}

.bet-money-input {
  margin-top: 6px;
}

.bet-price-toolbar .input-group .form-control,
.bet-cart-card .input-group .form-control,
.bet-section-card .form-control {
  height: 44px;
  border-radius: 14px;
  border: 1px solid rgba(42, 110, 107, 0.25);
  box-shadow: none;
  background: #fbfdfd;
  color: #1e2e2d;
}

.bet-price-toolbar .input-group-btn > .btn,
.bet-cart-card .input-group-btn > .btn {
  height: 44px;
  border-radius: 14px;
  border: 1px solid rgba(42, 110, 107, 0.18);
  background: linear-gradient(180deg, #ffffff 0%, #eff6f6 100%);
  color: #1A4F4B;
  font-weight: 600;
}

.bet-money-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.bet-money-chips button {
  min-width: 56px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(42, 110, 107, 0.16);
  box-shadow: 0 8px 16px rgba(26, 79, 75, 0.06);
}

.bet-subtype-group .btn,
#boxrunning .btn,
#boxhilow .btn,
#boxevenodd .btn,
#box-number2dtop .btn,
#box-number2ddown .btn,
#box-number3dtop .btn,
#box-number3dmix .btn {
  border-radius: 14px !important;
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  background: linear-gradient(180deg, #ffffff 0%, #f3f8f8 100%) !important;
  color: #1A4F4B !important;
  font-weight: 600;
  box-shadow: 0 8px 18px rgba(26, 79, 75, 0.05);
}

.bet-subtype-group .btn.btn-primary,
#boxrunning .btn.btn-primary,
#boxhilow .btn.btn-primary,
#boxevenodd .btn.btn-primary,
#box-number2dtop .btn.btn-primary,
#box-number2ddown .btn.btn-primary,
#box-number3dtop .btn.btn-primary,
#box-number3dmix .btn.btn-primary {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  color: #fff !important;
  border-color: transparent !important;
}

.bet-cart-card {
  position: sticky;
  top: 88px;
}

.bet-cart-card__title {
  position: relative;
  padding: 16px 18px;
}

.bet-cart-card__shortcut {
  position: absolute;
  top: 12px;
  right: 18px;
  border-radius: 999px;
  border: 0;
  padding: 7px 14px;
  font-weight: 700;
  box-shadow: 0 10px 18px rgba(255, 193, 7, 0.18);
}

.bet-cart-card__content {
  padding: 18px;
  background: transparent;
}

.bet-cart-card h4 {
  font-size: 14px;
  font-weight: 700;
  color: #1A4F4B;
  padding-bottom: 6px;
  border-bottom: 1px dashed rgba(42, 110, 107, 0.20);
}

.bet-cart-card .input-group-addon {
  border-radius: 14px 0 0 14px;
  border: 1px solid rgba(42, 110, 107, 0.22);
  background: #eef5f5;
  color: #1A4F4B;
  font-weight: 700;
}

.bet-cart-card .input-group-btn > .btn.btn-default {
  background: #f2f7f7 !important;
  color: #235E59 !important;
  border-color: rgba(42, 110, 107, 0.18) !important;
}

.bet-cart-card .input-group-btn > .btn.btn-danger {
  border-radius: 0 14px 14px 0;
}

.responsive-table table {
  overflow: hidden;
  border-radius: 18px;
  border: 1px solid rgba(42, 110, 107, 0.18);
  background: #fff;
}

.responsive-table th,
.responsive-table td {
  padding: 10px 12px;
  border-color: rgba(42, 110, 107, 0.12);
}

.overlimit-text {
  color: #c0392b;
}

@media only screen and (max-width: 991px) {
  .bet-cart-card {
    position: static;
    top: auto;
    margin-top: 16px;
  }

  .bet-slug-nav__list {
    gap: 8px;
    padding: 12px;
  }

  .bet-slug-nav__list > li {
    width: calc(50% - 4px);
  }

  .bet-slug-nav__list > li > a.btn-bet-info {
    display: flex;
    justify-content: center;
    min-height: 44px;
    align-items: center;
    text-align: center;
  }

  .bet-hero-card__name {
    font-size: 21px;
  }
}

@media only screen and (max-width: 767px) {
  .bet-page-container {
    padding-left: 8px;
    padding-right: 8px;
  }

  .bet-hero-card__title,
  .bet-section-card > .ibox-title,
  .bet-section-card > .ibox-content,
  .bet-cart-card__title,
  .bet-cart-card__content {
    padding-left: 14px;
    padding-right: 14px;
  }

  .bet-money-chips {
    gap: 8px;
  }

  .bet-money-chips button {
    min-width: 52px;
  }
}

/* =========================================
   PATCH 1.2
   ========================================= */

.nav-slug,
.nav-slug .navbar-nav,
.nav-slug .navbar-nav > li,
.nav-slug .navbar-nav > li > a,
.nav-slug .navbar-nav > li > a.btn-bet-info {
  background: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
  text-shadow: none !important;
}

.nav-slug .navbar-nav > li > a.btn-bet-info {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 46px !important;
  padding: 12px 22px !important;
  border-radius: 999px !important;
  border: 0 !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  background: linear-gradient(135deg, #ef6c00 0%, #dd5d00 100%) !important;
  box-shadow: 0 10px 20px rgba(221, 93, 0, 0.18) !important;
}

.nav-slug .navbar-nav > li.active > a.btn-bet-info,
.nav-slug .navbar-nav > li > a.btn-bet-info:hover,
.nav-slug .navbar-nav > li > a.btn-bet-info:focus {
  color: #ffffff !important;
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  outline: none !important;
}

.nav-slug .navbar-nav > li > a.btn-bet-info::before,
.nav-slug .navbar-nav > li > a.btn-bet-info::after,
.nav-slug .navbar-nav > li.active > a.btn-bet-info::before,
.nav-slug .navbar-nav > li.active > a.btn-bet-info::after {
  content: none !important;
  display: none !important;
}

.nav-slug .navbar-nav > li > a.btn-bet-info span,
.nav-slug .navbar-nav > li > a.btn-bet-info div,
.nav-slug .navbar-nav > li > a.btn-bet-info small,
.nav-slug .navbar-nav > li > a.btn-bet-info strong {
  color: inherit !important;
  background: transparent !important;
}

.nav-slug .navbar-nav > li.active,
.nav-slug .navbar-nav > li.active > a,
.nav-slug .navbar-nav > li.active > a:hover,
.nav-slug .navbar-nav > li.active > a:focus {
  background: transparent !important;
  background-color: transparent !important;
}

.money-chips {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 14px !important;
  overflow: visible !important;
  padding-top: 8px !important;
}

.money-chips > button,
.money-chips > .btn,
.money-chips .c1,
.money-chips .c5,
.money-chips .c10,
.money-chips .c50,
.money-chips .c100,
.money-chips .c500 {
  width: 56px !important;
  height: 56px !important;
  min-width: 56px !important;
  min-height: 56px !important;
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 50% !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  overflow: visible !important;
  line-height: 56px !important;
  box-shadow: none !important;
}

.money-chips > button:hover,
.money-chips > button:focus,
.money-chips > button:active {
  outline: none !important;
  transform: translateY(-1px);
}

.subtype-group .btn,
#betselected .btn,
#box-numbers .btn-default,
#box-numbers .btn-secondary,
#box-numbers .btn-block {
  color: #1A4F4B !important;
  text-shadow: none !important;
}

.subtype-group .btn.btn-primary,
#betselected .btn.btn-primary,
#box-numbers .btn-primary {
  color: #ffffff !important;
}

.subtype-group .btn.btn-default,
#box-numbers .btn-default,
#box-numbers .btn-secondary {
  background: linear-gradient(180deg, #ffffff 0%, #f3f8f8 100%) !important;
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  color: #1A4F4B !important;
}

.subtype-group .btn.btn-primary,
#box-numbers .btn.btn-primary {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: transparent !important;
  color: #ffffff !important;
}

#boxrule,
#boxrule h1,
#boxrule h2,
#boxrule h3,
#boxrule h4,
#boxrule h5,
#boxrule p,
#boxrule span,
#boxrule li,
#boxrule td,
#boxrule th,
#boxrule small,
#boxrule strong,
#cart-item-list,
#cart-item-list h1,
#cart-item-list h2,
#cart-item-list h3,
#cart-item-list h4,
#cart-item-list h5,
#cart-item-list p,
#cart-item-list span,
#cart-item-list label,
#cart-item-list td,
#cart-item-list th,
#cart-item-list small,
#cart-item-list strong {
  color: #1A4F4B !important;
  text-shadow: none !important;
}

#cart-item-list .btn-success,
#cart-item-list .btn-danger,
#cart-item-list .btn-warning,
#cart-item-list .btn-primary {
  color: #ffffff !important;
}

#cart-item-list input,
#cart-item-list select,
#cart-item-list textarea,
#boxrule input,
#boxrule select,
#boxrule textarea {
  color: #1e2e2d !important;
  background: #fbfdfd !important;
  -webkit-text-fill-color: #1e2e2d !important;
}

#boxrule .text-danger,
#cart-item-list .text-danger {
  color: #d64b4b !important;
}

.ibox-title,
.ibox-title h1,
.ibox-title h2,
.ibox-title h3,
.ibox-title h4,
.ibox-title h5,
.ibox-title span,
.ibox-title a:not(.btn):not(.btn-bet-info) {
  color: #1A4F4B !important;
}

.nav-search-permutation .btn,
.nav-search-permutation .btn-default {
  color: #1A4F4B !important;
  background: linear-gradient(180deg, #ffffff 0%, #eff6f6 100%) !important;
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  text-shadow: none !important;
}

.row-current-number,
.row-current-number input,
.row-current-number .form-control,
.column-main-lotto input,
.column-main-lotto .form-control {
  color: #1e2e2d !important;
  background: #ffffff !important;
  border-color: rgba(42, 110, 107, 0.22) !important;
}

.nav > li.active {
  border-left: 0 !important;
}

@media only screen and (max-width: 991px) {
  .money-chips > button,
  .money-chips > .btn,
  .money-chips .c1,
  .money-chips .c5,
  .money-chips .c10,
  .money-chips .c50,
  .money-chips .c100,
  .money-chips .c500 {
    width: 52px !important;
    height: 52px !important;
    min-width: 52px !important;
    min-height: 52px !important;
    line-height: 52px !important;
  }
}

/* =========================================
   PATCH 1.2.1
   ========================================= */

.nav-slug .navbar-nav > li.active > a.btn-bet-info,
.bet-slug-nav__list > li.active > a.btn-bet-info,
.nav-slug .navbar-nav > li > a.btn-bet-info:hover,
.nav-slug .navbar-nav > li > a.btn-bet-info:focus {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  color: #ffffff !important;
  border: 0 !important;
  text-shadow: none !important;
}

.nav-slug .navbar-nav > li.active > a.btn-bet-info *,
.bet-slug-nav__list > li.active > a.btn-bet-info * {
  color: #ffffff !important;
}

.money-chips,
.money-chips.bet-money-chips {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 12px !important;
  align-items: center !important;
}

.money-chips > button,
.money-chips.bet-money-chips > button {
  flex: 0 0 58px !important;
  width: 58px !important;
  height: 58px !important;
  min-width: 58px !important;
  min-height: 58px !important;
  max-width: 58px !important;
  max-height: 58px !important;
  display: inline-block !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background-color: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: visible !important;
  transform: none !important;
  vertical-align: top !important;
}

#box-number2dtop .btn,
#box-number2ddown .btn,
#boxrunning .btn,
.subtype-group .btn,
.nav-search-permutation .btn,
.nav-search-permutation .btn-default {
  color: #1A4F4B !important;
  text-shadow: none !important;
}

#box-number2dtop .btn *,
#box-number2ddown .btn *,
#boxrunning .btn *,
.subtype-group .btn *,
.nav-search-permutation .btn *,
.nav-search-permutation .btn-default * {
  color: inherit !important;
}

#box-number2dtop .btn.btn-primary,
#box-number2ddown .btn.btn-primary,
#boxrunning .btn.btn-primary,
.subtype-group .btn.btn-primary,
.nav-search-permutation .btn.btn-primary {
  color: #ffffff !important;
}

#box-number2dtop .btn.btn-primary *,
#box-number2ddown .btn.btn-primary *,
#boxrunning .btn.btn-primary *,
.subtype-group .btn.btn-primary *,
.nav-search-permutation .btn.btn-primary * {
  color: #ffffff !important;
}

#box-number2dtop .btn,
#box-number2ddown .btn,
#boxrunning .btn,
.subtype-group .btn,
.nav-search-permutation .btn {
  min-height: 42px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1.2 !important;
  text-align: center !important;
  padding: 8px 14px !important;
  vertical-align: middle !important;
}

#box-number2dtop .btn span,
#box-number2ddown .btn span,
#boxrunning .btn span,
.subtype-group .btn span,
.nav-search-permutation .btn span {
  display: inline-block !important;
  line-height: 1.2 !important;
}

#boxrule {
  position: relative !important;
  top: auto !important;
  bottom: auto !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;
  margin-top: 18px !important;
  clear: both !important;
}

#boxrule.affix,
#boxrule.fixed,
#boxrule.sticky,
#boxrule[style*="position: fixed"],
#boxrule[style*="position: sticky"] {
  position: relative !important;
  top: auto !important;
}

#cart-item-list {
  position: relative !important;
}

.bet-cart-card {
  position: sticky !important;
  top: 88px !important;
}

@media only screen and (max-width: 991px) {
  .money-chips > button,
  .money-chips.bet-money-chips > button {
    flex: 0 0 54px !important;
    width: 54px !important;
    height: 54px !important;
    min-width: 54px !important;
    min-height: 54px !important;
    max-width: 54px !important;
    max-height: 54px !important;
  }

  .bet-cart-card {
    position: static !important;
    top: auto !important;
  }
}

/* =========================================
   PATCH 1.2.2
   ========================================= */

.money-chips.bet-money-chips,
.money-chips {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 12px !important;
  position: relative !important;
  overflow: visible !important;
}

.money-chips.bet-money-chips > button,
.money-chips > button,
.money-chips .c1,
.money-chips .c5,
.money-chips .c10,
.money-chips .c50,
.money-chips .c100,
.money-chips .c500 {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  right: auto !important;
  bottom: auto !important;
  float: none !important;
  clear: none !important;
  display: inline-block !important;
  flex: 0 0 58px !important;
  width: 58px !important;
  height: 58px !important;
  min-width: 58px !important;
  min-height: 58px !important;
  max-width: 58px !important;
  max-height: 58px !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 50% !important;
  background-color: transparent !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background-size: contain !important;
  box-shadow: none !important;
  overflow: visible !important;
  transform: none !important;
  z-index: 1 !important;
}

#boxdown strong {
  display: block !important;
  margin-bottom: 10px !important;
  color: #1A4F4B !important;
  text-align: center !important;
}

#boxdown .btn-group {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  gap: 6px !important;
  width: 100% !important;
}

#boxdown .btn-group > .btn {
  float: none !important;
  min-width: 38px !important;
  height: 38px !important;
  padding: 0 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
  text-align: center !important;
  border-radius: 10px !important;
  background: linear-gradient(180deg, #ffffff 0%, #f3f8f8 100%) !important;
  border: 1px solid rgba(42, 110, 107, 0.18) !important;
  color: #1A4F4B !important;
  text-shadow: none !important;
  box-shadow: 0 6px 14px rgba(26, 79, 75, 0.05) !important;
}

#boxdown .btn-group > .btn *,
#boxdown .btn-group > .btn.btn-default *,
#boxdown .btn-group > .btn.btn-sm * {
  color: inherit !important;
}

#boxdown .btn-group > .btn.active,
#boxdown .btn-group > .btn.btn-primary,
#boxdown .btn-group > .btn:active {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: transparent !important;
  color: #ffffff !important;
}

#boxdown .btn-group > .btn.active *,
#boxdown .btn-group > .btn.btn-primary *,
#boxdown .btn-group > .btn:active * {
  color: #ffffff !important;
}

#boxdown .column .btn,
#boxdown .column .btn.btn-default,
#boxdown .column .btn.btn-block {
  min-height: 42px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1.1 !important;
  text-align: center !important;
  color: #1A4F4B !important;
  text-shadow: none !important;
}

#boxdown .column .btn *,
#boxdown .column .btn.btn-default * {
  color: inherit !important;
}

.bet-cart-card {
  position: relative !important;
  top: auto !important;
  z-index: 1 !important;
  margin-bottom: 18px !important;
}

#cart-item-list {
  position: relative !important;
}

#boxrule {
  position: relative !important;
  top: auto !important;
  bottom: auto !important;
  left: auto !important;
  right: auto !important;
  transform: none !important;
  clear: both !important;
  margin-top: 18px !important;
  z-index: 1 !important;
}

#boxrule,
#boxrule h1,
#boxrule h2,
#boxrule h3,
#boxrule h4,
#boxrule h5,
#boxrule p,
#boxrule span,
#boxrule label,
#boxrule td,
#boxrule th,
#boxrule small,
#boxrule strong,
#boxrule li,
#boxrule div {
  color: #1A4F4B !important;
  text-shadow: none !important;
}

@media only screen and (max-width: 991px) {
  .money-chips.bet-money-chips > button,
  .money-chips > button,
  .money-chips .c1,
  .money-chips .c5,
  .money-chips .c10,
  .money-chips .c50,
  .money-chips .c100,
  .money-chips .c500 {
    flex: 0 0 54px !important;
    width: 54px !important;
    height: 54px !important;
    min-width: 54px !important;
    min-height: 54px !important;
    max-width: 54px !important;
    max-height: 54px !important;
  }

  #boxdown .btn-group > .btn {
    min-width: 34px !important;
    height: 34px !important;
    padding: 0 8px !important;
  }
}

/* =========================================
   PATCH 1.2.3
   ========================================= */

.money-chips > button.c1,
.money-chips > button.c5,
.money-chips > button.c10,
.money-chips > button.c50,
.money-chips > button.c100,
.money-chips > button.c500 {
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
  background-position: center center !important;
  background-color: transparent !important;
}

.down-inline-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 16px;
  margin-bottom: 8px;
}

.down-inline-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 0;
  min-width: 0;
}

.down-inline-label {
  width: 56px;
  flex: 0 0 58px;
  text-align: right;
  color: #1A4F4B !important;
}

.down-inline-buttons {
  display: flex;
  align-items: center;
  gap: 3px;
  flex-wrap: nowrap;
}

.down-inline-buttons > .btn {
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding: 0;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-size: 12px;
}

.down-inline-buttons > .btn.btn-primary,
.down-inline-buttons > .btn.active,
.down-inline-buttons > .btn:active {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: transparent !important;
  color: #ffffff !important;
}

@media only screen and (max-width: 1199px) {
  .down-inline-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .down-inline-group {
    flex-wrap: wrap;
  }
}

.money-chips.bet-money-chips {
  display: flex !important;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  margin-top: 12px;
  overflow: visible !important;
}

.coin-chip {
  --chip-main: #235E59;
  --chip-dark: #1A4F4B;
  --chip-light: #2A8C87;

  position: relative;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border: 0;
  border-radius: 50%;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-weight: 900;
  font-size: 15px;
  line-height: 1;
  color: #ffffff !important;
  cursor: pointer;
  user-select: none;

  z-index: 1;
  overflow: hidden;
  text-indent: 0 !important;

  background:
    radial-gradient(circle at 30% 28%, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.45) 14%, rgba(255,255,255,0) 28%),
    radial-gradient(circle at center, var(--chip-light) 0%, var(--chip-main) 58%, var(--chip-dark) 100%);
  box-shadow:
    inset 0 2px 3px rgba(255,255,255,0.38),
    inset 0 -4px 6px rgba(0,0,0,0.18),
    0 8px 16px rgba(26, 79, 75, 0.14);
}

.coin-chip::before {
  content: "";
  position: absolute;
  inset: 4px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.92);
  box-shadow:
    inset 0 1px 2px rgba(255,255,255,0.45),
    0 0 0 1px rgba(0,0,0,0.05);
  z-index: 1;
  pointer-events: none;
}

.coin-chip::after {
  content: "";
  position: absolute;
  inset: 12px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 30%, rgba(255,255,255,0.18), rgba(255,255,255,0.04) 45%, rgba(255,255,255,0) 70%);
  pointer-events: none;
  z-index: 1;
}

.coin-chip > span,
.coin-chip {
  position: relative;
}

.coin-chip {
  z-index: 2;
}

.coin-chip,
.coin-chip:focus,
.coin-chip:hover,
.coin-chip:active {
  text-shadow:
    0 1px 2px rgba(0,0,0,0.45),
    0 0 1px rgba(0,0,0,0.3);
}

.coin-chip:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow:
    inset 0 2px 3px rgba(255,255,255,0.42),
    inset 0 -4px 6px rgba(0,0,0,0.2),
    0 12px 20px rgba(26, 79, 75, 0.18);
}

.coin-chip:focus {
  outline: none;
  box-shadow:
    inset 0 2px 3px rgba(255,255,255,0.42),
    inset 0 -4px 6px rgba(0,0,0,0.2),
    0 0 0 4px rgba(26, 79, 75, 0.18),
    0 12px 20px rgba(26, 79, 75, 0.18);
}

.coin-chip.is-active,
.coin-chip:active {
  transform: translateY(0) scale(0.98);
  filter: saturate(1.05);
  box-shadow:
    inset 0 2px 3px rgba(255,255,255,0.28),
    inset 0 -3px 5px rgba(0,0,0,0.24),
    0 6px 12px rgba(26, 79, 75, 0.14);
}

.coin-chip--1 {
  --chip-main: #1A4F4B;
  --chip-dark: #0d2e2b;
  --chip-light: #2A8C87;
}

.coin-chip--5 {
  --chip-main: #b93d89;
  --chip-dark: #7f285c;
  --chip-light: #de72b1;
}

.coin-chip--10 {
  --chip-main: #1f61bf;
  --chip-dark: #143d78;
  --chip-light: #5b95eb;
}

.coin-chip--50 {
  --chip-main: #2ea6c8;
  --chip-dark: #1d6f87;
  --chip-light: #72d2ee;
}

.coin-chip--100 {
  --chip-main: #cc3535;
  --chip-dark: #822020;
  --chip-light: #f07070;
}

.coin-chip--500 {
  --chip-main: #74a319;
  --chip-dark: #4d6a10;
  --chip-light: #addb49;
  font-size: 15px;
}

.coin-chip--500 {
  font-size: 13px;
}

@media only screen and (max-width: 991px) {
  .coin-chip {
    width: 54px;
    height: 54px;
    min-width: 54px;
    min-height: 54px;
    font-size: 14px;
  }

  .coin-chip--500 {
    font-size: 12px;
  }
}

@media only screen and (max-width: 767px) {
  .money-chips.bet-money-chips {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 6px !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 4px;
  }

  .money-chips.bet-money-chips > .coin-chip {
    flex: 0 0 42px !important;
    width: 42px !important;
    height: 42px !important;
    min-width: 42px !important;
    min-height: 42px !important;
  }

  .money-chips.bet-money-chips > .coin-chip::before {
    inset: 4px !important;
    border-width: 2px !important;
  }

  .money-chips.bet-money-chips > .coin-chip::after {
    inset: 8px !important;
  }

  .money-chips.bet-money-chips > .coin-chip span {
    font-size: 11px !important;
  }

  .money-chips.bet-money-chips > .coin-chip.coin-chip--100 span {
    font-size: 9px !important;
  }

  .money-chips.bet-money-chips > .coin-chip.coin-chip--500 span {
    font-size: 8px !important;
  }
}

@media only screen and (max-width: 767px) {
  .money-chips.bet-money-chips > .coin-chip {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  .money-chips.bet-money-chips > .coin-chip span {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 100% !important;
    line-height: 1 !important;
    text-align: center !important;
    margin: 0 !important;
    padding: 0 !important;
    transform: translateY(-1px) !important;
  }
}

@media only screen and (max-width: 767px) {
  #betselected.bet-price-toolbar {
    position: relative !important;
    padding-top: 18px !important;
    padding-bottom: 18px !important;
    min-height: 96px !important;
  }

  #betselected.bet-price-toolbar > h5 {
    margin: 0 !important;
    line-height: 44px !important;
    padding-right: 170px !important;
  }

  #betselected.bet-price-toolbar > .clearfix {
    display: none !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input {
    margin-top: 0 !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input > .row > label {
    display: none !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input > .row > .col-xs-6.col-md-3 {
    position: absolute !important;
    top: 18px !important;
    right: 16px !important;
    width: auto !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    z-index: 2 !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input > .row > .col-xs-6.col-md-3 .input-group {
    display: flex !important;
    align-items: center !important;
    width: auto !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input > .row > .col-xs-6.col-md-3 .form-control.money {
    width: 76px !important;
    height: 44px !important;
    text-align: center !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input > .row > .col-xs-6.col-md-3 .input-group-btn > .btn {
    height: 44px !important;
    white-space: nowrap !important;
  }

  #betselected.bet-price-toolbar .money-chips.bet-money-chips {
    margin-top: 18px !important;
  }
}

@media only screen and (max-width: 767px) {
  #betselected.bet-price-toolbar > .bet-money-input > .row > .col-xs-6.col-md-3 .input-group {
    display: flex !important;
    align-items: stretch !important;
    flex-wrap: nowrap !important;
    width: auto !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input > .row > .col-xs-6.col-md-3 .form-control.money {
    width: 72px !important;
    min-width: 72px !important;
    height: 44px !important;
    text-align: center !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input > .row > .col-xs-6.col-md-3 .input-group-btn {
    display: flex !important;
    width: auto !important;
    flex: 0 0 auto !important;
  }

  #betselected.bet-price-toolbar > .bet-money-input > .row > .col-xs-6.col-md-3 .input-group-btn > .btn {
    height: 44px !important;
    padding: 0 14px !important;
    white-space: nowrap !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 767px) {
  .nav-slug.bet-slug-nav {
    margin-bottom: 0 !important;
  }

  .nav-slug.bet-slug-nav .navbar-collapse {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .bet-slug-nav__list {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
    padding: 14px !important;
    margin: 0 !important;
    width: 100% !important;
  }

  .bet-slug-nav__list > li {
    width: 100% !important;
    margin: 0 !important;
    float: none !important;
  }

  .bet-slug-nav__list > li:first-child {
    grid-column: 1 / -1 !important;
  }

  .bet-slug-nav__list > li > a.btn-bet-info {
    width: 100% !important;
    min-height: 46px !important;
    padding: 10px 14px !important;
    border-radius: 18px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 1.2 !important;
    white-space: normal !important;
  }

  .bet-slug-nav__list > li > a.btn-bet-info {
    background: #ffffff !important;
    color: #1A4F4B !important;
    border: 1px solid rgba(42, 110, 107, 0.18) !important;
    box-shadow: 0 8px 18px rgba(26, 79, 75, 0.06) !important;
  }

  .bet-slug-nav__list > li.active > a.btn-bet-info,
  .bet-slug-nav__list > li > a.btn-bet-info:hover,
  .bet-slug-nav__list > li > a.btn-bet-info:focus {
    background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
    color: #ffffff !important;
    border-color: transparent !important;
    box-shadow: 0 10px 22px rgba(26, 79, 75, 0.16) !important;
  }

  .bet-slug-nav__list > li:last-child > a.btn-bet-info {
    background: linear-gradient(135deg, #ef7a00 0%, #df6400 100%) !important;
    color: #ffffff !important;
    border-color: transparent !important;
    box-shadow: 0 10px 22px rgba(223, 100, 0, 0.16) !important;
  }

  .bet-slug-nav__list > li:last-child.active > a.btn-bet-info,
  .bet-slug-nav__list > li:last-child > a.btn-bet-info:hover,
  .bet-slug-nav__list > li:last-child > a.btn-bet-info:focus {
    background: linear-gradient(135deg, #de6c00 0%, #c75900 100%) !important;
    color: #ffffff !important;
  }
}

@media only screen and (max-width: 767px) {
  .bet-slug-nav__list > li:last-child > a.btn-bet-info {
    font-size: 14px !important;
    line-height: 1.1 !important;
    padding: 10px 12px !important;
  }
}

@media only screen and (max-width: 767px) {
  .down-inline-buttons {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
  }
}

@media only screen and (max-width: 932px) and (orientation: landscape) {
  .nav-slug.bet-slug-nav {
    margin-bottom: 0 !important;
  }

  .nav-slug.bet-slug-nav .navbar-collapse {
    padding-left: 0 !important;
    padding-right: 0 !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
  }

  .bet-slug-nav__list {
    display: flex !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 10px !important;
    padding: 14px !important;
    margin: 0 !important;
    width: max-content !important;
    min-width: 100% !important;
  }

  .bet-slug-nav__list > li {
    width: auto !important;
    margin: 0 !important;
    float: none !important;
    flex: 0 0 auto !important;
  }

  .bet-slug-nav__list > li:first-child {
    grid-column: auto !important;
  }

  .bet-slug-nav__list > li > a.btn-bet-info {
    width: auto !important;
    min-height: 42px !important;
    padding: 9px 14px !important;
    border-radius: 999px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    white-space: nowrap !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 1.1 !important;
  }

  .bet-slug-nav__list > li:last-child > a.btn-bet-info {
    font-size: 13px !important;
    padding: 9px 12px !important;
  }
}

#boxdown button.btn.btn-primary,
#boxdown button.btn.btn-primary:hover,
#boxdown button.btn.btn-primary:focus,
#boxdown button.btn.btn-primary:active {
  color: #fff !important;
}

#boxdown button.btn.btn-primary.color0,
#boxdown button.btn.btn-primary.color1,
#boxdown button.btn.btn-primary.color2,
#boxdown button.btn.btn-primary.color3,
#boxdown button.btn.btn-primary.color4,
#boxdown button.btn.btn-primary.color5,
#boxdown button.btn.btn-primary.color6,
#boxdown button.btn.btn-primary.color7,
#boxdown button.btn.btn-primary.color8,
#boxdown button.btn.btn-primary.color9 {
  color: #fff !important;
}

#boxdown button.btn.btn-primary span,
#boxdown button.btn.btn-primary strong {
  color: #fff !important;
}

/* ===== number tile base ===== */
.bet-number-tile {
  position: relative;
  min-height: 46px;
  border-radius: 16px !important;
  border: 1px solid rgba(42, 110, 107, 0.16) !important;
  box-shadow: 0 10px 18px rgba(26, 79, 75, 0.05);
  font-weight: 800;
  letter-spacing: 0.2px;
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    border-color 0.18s ease,
    filter 0.18s ease;
  overflow: hidden;
}

.bet-number-tile:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(26, 79, 75, 0.09);
  filter: saturate(1.03);
}

.bet-number-tile:focus,
.bet-number-tile:active {
  outline: none !important;
}

.bet-number-tile::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(255,255,255,0.18) 0%,
    rgba(255,255,255,0.03) 48%,
    rgba(0,0,0,0.03) 100%
  );
  pointer-events: none;
}

/* ===== softened default row colors ===== */
#boxup .btn.btn-default.bet-number-tile.color0,
#boxfront .btn.btn-default.bet-number-tile.color0,
#boxdown .btn.btn-default.bet-number-tile.color0 {
  background: linear-gradient(135deg, #7abfbc 0%, #5eaaa7 100%) !important;
  border-color: #55a09d !important;
  color: #f8ffff !important;
}

#boxup .btn.btn-default.bet-number-tile.color1,
#boxfront .btn.btn-default.bet-number-tile.color1,
#boxdown .btn.btn-default.bet-number-tile.color1 {
  background: linear-gradient(135deg, #a8c98a 0%, #8db36a 100%) !important;
  border-color: #84ab60 !important;
  color: #fbfff8 !important;
}

#boxup .btn.btn-default.bet-number-tile.color2,
#boxfront .btn.btn-default.bet-number-tile.color2,
#boxdown .btn.btn-default.bet-number-tile.color2 {
  background: linear-gradient(135deg, #8fc2c9 0%, #73aeb7 100%) !important;
  border-color: #6aa5ad !important;
  color: #f8feff !important;
}

#boxup .btn.btn-default.bet-number-tile.color3,
#boxfront .btn.btn-default.bet-number-tile.color3,
#boxdown .btn.btn-default.bet-number-tile.color3 {
  background: linear-gradient(135deg, #99aed8 0%, #7f98c7 100%) !important;
  border-color: #748dbc !important;
  color: #fbfcff !important;
}

#boxup .btn.btn-default.bet-number-tile.color4,
#boxfront .btn.btn-default.bet-number-tile.color4,
#boxdown .btn.btn-default.bet-number-tile.color4 {
  background: linear-gradient(135deg, #b59bcf 0%, #9a80bc 100%) !important;
  border-color: #9075b2 !important;
  color: #fdfaff !important;
}

#boxup .btn.btn-default.bet-number-tile.color5,
#boxfront .btn.btn-default.bet-number-tile.color5,
#boxdown .btn.btn-default.bet-number-tile.color5 {
  background: linear-gradient(135deg, #d2a0bf 0%, #ba82a6 100%) !important;
  border-color: #ae769a !important;
  color: #fffafd !important;
}

#boxup .btn.btn-default.bet-number-tile.color6,
#boxfront .btn.btn-default.bet-number-tile.color6,
#boxdown .btn.btn-default.bet-number-tile.color6 {
  background: linear-gradient(135deg, #d8ab92 0%, #c18e72 100%) !important;
  border-color: #b68367 !important;
  color: #fffaf8 !important;
}

#boxup .btn.btn-default.bet-number-tile.color7,
#boxfront .btn.btn-default.bet-number-tile.color7,
#boxdown .btn.btn-default.bet-number-tile.color7 {
  background: linear-gradient(135deg, #dcc08d 0%, #c6a56c 100%) !important;
  border-color: #bb9b62 !important;
  color: #fffdf8 !important;
}

#boxup .btn.btn-default.bet-number-tile.color8,
#boxfront .btn.btn-default.bet-number-tile.color8,
#boxdown .btn.btn-default.bet-number-tile.color8 {
  background: linear-gradient(135deg, #a9bbc4 0%, #8ea4af 100%) !important;
  border-color: #8499a4 !important;
  color: #fbfdff !important;
}

#boxup .btn.btn-default.bet-number-tile.color9,
#boxfront .btn.btn-default.bet-number-tile.color9,
#boxdown .btn.btn-default.bet-number-tile.color9 {
  background: linear-gradient(135deg, #afb8be 0%, #96a1a8 100%) !important;
  border-color: #8c979e !important;
  color: #fcfdff !important;
}

#boxup .btn.btn-default.bet-number-tile,
#boxfront .btn.btn-default.bet-number-tile,
#boxdown .btn.btn-default.bet-number-tile {
  box-shadow: 0 4px 10px rgba(0,0,0,0.04) !important;
  filter: saturate(0.82) brightness(1.04) !important;
}

/* ===== selected state ===== */
#boxup .btn.btn-primary.bet-number-tile,
#boxfront .btn.btn-primary.bet-number-tile,
#boxdown .btn.btn-primary.bet-number-tile {
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  border-color: #1A4F4B !important;
  color: #fff !important;
  box-shadow:
    0 0 0 2px rgba(255,255,255,0.92),
    0 0 0 5px rgba(26, 79, 75, 0.22),
    0 10px 20px rgba(26, 79, 75, 0.18) !important;
  z-index: 1;
}

#boxup .btn.btn-primary.bet-number-tile *,
#boxfront .btn.btn-primary.bet-number-tile *,
#boxdown .btn.btn-primary.bet-number-tile * {
  color: #fff !important;
}

@media only screen and (max-width: 767px) {
  .bet-number-tile {
    min-height: 42px;
    border-radius: 14px !important;
    font-size: 13px !important;
    padding-left: 4px;
    padding-right: 4px;
  }
}

/* =========================================================
   BET MODAL THEME
========================================================= */

#modal-confirm-checkout .modal-dialog,
#modal-checkout-success .modal-dialog {
  width: 720px;
  max-width: calc(100vw - 24px);
  margin: 28px auto;
}

#modal-confirm-checkout .modal-content,
#modal-checkout-success .modal-content {
  overflow: hidden;
  border: 1px solid rgba(42, 110, 107, 0.16);
  border-radius: 28px;
  background:
    radial-gradient(circle at top left, rgba(42, 110, 107, 0.12), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f4fafa 100%);
  box-shadow: 0 28px 64px rgba(26, 79, 75, 0.16);
  color: #1e2e2d !important;
}

#modal-confirm-checkout .modal-header,
#modal-checkout-success .modal-header {
  padding: 22px 24px 18px !important;
  border-bottom: 1px solid rgba(42, 110, 107, 0.14);
  background:
    radial-gradient(circle at top left, rgba(42, 110, 107, 0.18), transparent 34%),
    linear-gradient(180deg, #f8fcfc 0%, #eef6f6 100%);
  text-align: center;
}

#modal-confirm-checkout .modal-title,
#modal-checkout-success .modal-title {
  font-size: 24px;
  line-height: 1.4;
  font-weight: 800;
  color: #1A4F4B !important;
  margin-top: 0;
  margin-bottom: 6px;
}

#modal-confirm-checkout .font-bold,
#modal-checkout-success .font-bold,
#modal-confirm-checkout small,
#modal-checkout-success small {
  color: #2a6e6b !important;
  font-size: 13px;
  letter-spacing: 0.02em;
}

#modal-confirm-checkout .close,
#modal-checkout-success .close {
  opacity: 1;
  color: #235E59;
  text-shadow: none;
}

#modal-confirm-checkout .close:hover,
#modal-checkout-success .close:hover {
  color: #1A4F4B;
}

#modal-confirm-checkout .modal-body,
#modal-checkout-success .modal-body {
  padding: 20px 22px !important;
  background: transparent;
  color: #1e2e2d !important;
}

#modal-confirm-checkout .modal-body h3,
#modal-confirm-checkout .modal-body h4,
#modal-checkout-success .modal-body h3,
#modal-checkout-success .modal-body h4,
#modal-confirm-checkout .modal-body strong,
#modal-checkout-success .modal-body strong {
  color: #1A4F4B !important;
}

#modal-confirm-checkout .p-sm,
#modal-checkout-success .p-sm {
  padding: 18px 20px !important;
}

#modal-confirm-checkout .border-top,
#modal-checkout-success .border-top,
#modal-confirm-checkout .border-bottom,
#modal-checkout-success .border-bottom {
  border-color: rgba(42, 110, 107, 0.12) !important;
}

#modal-confirm-checkout hr,
#modal-checkout-success hr {
  border-top: 1px dashed rgba(42, 110, 107, 0.16);
}

#modal-confirm-checkout .row,
#modal-checkout-success .row {
  margin-left: -8px;
  margin-right: -8px;
}

#modal-confirm-checkout .row > [class*="col-"],
#modal-checkout-success .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

#modal-confirm-checkout .btn,
#modal-checkout-success .btn {
  height: 52px;
  border-radius: 16px !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
}

#modal-confirm-checkout .btn.btn-primary,
#modal-checkout-success .btn.btn-primary {
  border: 0 !important;
  color: #fff !important;
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%) !important;
  box-shadow: 0 14px 28px rgba(26, 79, 75, 0.20);
}

#modal-confirm-checkout .btn.btn-primary:hover,
#modal-checkout-success .btn.btn-primary:hover,
#modal-confirm-checkout .btn.btn-primary:focus,
#modal-checkout-success .btn.btn-primary:focus {
  color: #fff !important;
  background: linear-gradient(135deg, #1A4F4B 0%, #235E59 100%) !important;
}

#modal-confirm-checkout .btn.btn-danger,
#modal-confirm-checkout .btn.btn-default,
#modal-checkout-success .btn.btn-danger,
#modal-checkout-success .btn.btn-default {
  border: 1px solid rgba(42, 110, 107, 0.16) !important;
  color: #235E59 !important;
  background: linear-gradient(180deg, #ffffff 0%, #eef5f5 100%) !important;
  box-shadow: none !important;
}

#modal-confirm-checkout .btn.btn-danger:hover,
#modal-confirm-checkout .btn.btn-default:hover,
#modal-checkout-success .btn.btn-danger:hover,
#modal-checkout-success .btn.btn-default:hover {
  color: #1A4F4B !important;
  background: linear-gradient(180deg, #fdfefd 0%, #e9f1f1 100%) !important;
}

#modal-confirm-checkout .col-xs-12.m-t-sm {
  padding-left: 18px;
  padding-right: 18px;
}

#modal-confirm-checkout .col-xs-12.m-t-sm h4 {
  font-size: 14px;
  font-weight: 800;
}

#modal-confirm-checkout .col-xs-12.m-t-sm .row {
  padding: 8px 0;
  border-bottom: 1px dashed rgba(42, 110, 107, 0.10);
}

#modal-confirm-checkout .col-xs-12.m-t-sm .row:last-child {
  border-bottom: 0;
}

#modal-confirm-checkout .text-right,
#modal-checkout-success .text-right {
  color: #1A4F4B;
}

#modal-checkout-success .modal-header h1 {
  width: 92px;
  height: 92px;
  margin: 0 auto 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1A4F4B 0%, #2A6E6B 100%);
  box-shadow: 0 16px 34px rgba(26, 79, 75, 0.22);
}

#modal-checkout-success .modal-header h1 .fa {
  font-size: 42px !important;
  color: #ffffff !important;
}

#modal-checkout-success .text-navy {
  color: #ffffff !important;
}

#modal-checkout-success .modal-body + .p-sm,
#modal-checkout-success .p-sm.text-center {
  background: rgba(255, 255, 255, 0.50);
}

#modal-checkout-success .col-xs-12.m-t-sm {
  padding-left: 18px;
  padding-right: 18px;
}

#modal-checkout-success .col-xs-12.m-t-sm h4 {
  font-size: 14px;
  font-weight: 800;
  color: #1A4F4B !important;
}

#modal-checkout-success .col-xs-12.m-t-sm > div {
  font-size: 14px;
  color: #1e2e2d !important;
}

#modal-checkout-success [style*="color: blue"] {
  color: #1A4F4B !important;
  font-weight: 800;
}

#modal-checkout-success .text-danger {
  color: #c0392b !important;
  font-weight: 800;
}

#modal-checkout-success .col-xs-12.m-t-sm:last-of-type {
  margin-top: 18px !important;
  padding-top: 8px;
}

@media only screen and (max-width: 767px) {
  #modal-confirm-checkout .modal-dialog,
  #modal-checkout-success .modal-dialog {
    width: auto;
    max-width: calc(100vw - 16px);
    margin: 12px auto;
  }

  #modal-confirm-checkout .modal-content,
  #modal-checkout-success .modal-content {
    border-radius: 22px;
  }

  #modal-confirm-checkout .modal-header,
  #modal-checkout-success .modal-header {
    padding: 18px 16px 16px !important;
  }

  #modal-confirm-checkout .modal-title,
  #modal-checkout-success .modal-title {
    font-size: 20px;
  }

  #modal-confirm-checkout .btn,
  #modal-checkout-success .btn {
    height: 48px;
    font-size: 14px !important;
  }

  #modal-checkout-success .modal-header h1 {
    width: 78px;
    height: 78px;
    margin-bottom: 12px;
  }

  #modal-checkout-success .modal-header h1 .fa {
    font-size: 34px !important;
  }
}
</style>
